import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "../Purchase/MyCart.css";
import { Navbar } from "../Common/Navbar/Navbar";
import { Footer } from "../Common/Footer/Footer";
import { Popup } from "../Common/Popup/Popup";
// import { ToastContainer, toast } from "react-toastify";
import DeleteIcon from "../../Images/BundlDetail/deleteicon.svg";
import BlackDollor from "../../Images/BundlDetail/blackdollor.svg";
import BlackTime from "../../Images/BundlDetail/blacktime.svg";
import Blackupload from "../../Images/Questionnaire/upload.svg";
import { base_url } from "../Auth/BackendAPIUrl";
import { useLocation, useNavigate } from "react-router-dom";
import { ConfigToken } from "../Auth/ConfigToken";
import PhoneNumberInput from "../Pages/PhoneNumberInput";
import backIcon from "../../Images/backIcon.svg";
import { useSearchParams } from "react-router-dom";
import { Bgloader } from "../Common/Background/Bgloader";
import ClipLoader from "react-spinners/ClipLoader";
import Riyal from "../../Images/BundlDetail/riyalnew.png";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";
import { amountDecimal } from "../Utils/amountDecimal";
import toast, { Toaster } from "react-hot-toast";
import { processArabicText } from "../Utils/arabicFontParenthesisChecker";
import useToastMessage from "../Pages/Toaster/Toaster";
import { convertBundlEnglishToRoute } from "./bundlRouteUtils";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// Helper function to format amount with 2 decimal places if needed
const formatAmountWithDecimals = (amount) => {
  const numAmount = parseFloat(amount) || 0;
  // Check if amount has decimals
  if (numAmount % 1 !== 0) {
    // Has decimals - format to 2 decimal places
    return amountDecimal(parseFloat(numAmount.toFixed(2)));
  } else {
    // Whole number - show as is
    return amountDecimal(Math.round(numAmount));
  }
};

let toastId = null;

const VisaSvg = () => (
  <svg viewBox="0 0 36 16" className="h-5 w-auto" aria-label="Visa">
    <rect width="36" height="16" rx="2" fill="#ffffff" stroke="#e5e7eb" />
    <text
      x="18"
      y="12"
      textAnchor="middle"
      fontFamily="Arial, sans-serif"
      fontWeight="900"
      fontStyle="italic"
      fontSize="9"
      fill="#1A1F71"
      letterSpacing="0.3"
    >
      VISA
    </text>
  </svg>
);

const MastercardSvg = () => (
  <svg viewBox="0 0 26 16" className="h-5 w-auto" aria-label="Mastercard">
    <rect width="26" height="16" rx="2" fill="#ffffff" stroke="#e5e7eb" />
    <circle cx="10.5" cy="8" r="4" fill="#EB001B" />
    <circle cx="15.5" cy="8" r="4" fill="#F79E1B" />
    <path d="M13 5a4 4 0 0 0 0 6 4 4 0 0 0 0-6Z" fill="#FF5F00" />
  </svg>
);

const MadaSvg = () => (
  <svg viewBox="0 0 32 16" className="h-5 w-auto" aria-label="Mada">
    <rect width="32" height="16" rx="2" fill="#ffffff" stroke="#e5e7eb" />
    <text
      x="16"
      y="7"
      textAnchor="middle"
      fontFamily="Arial, sans-serif"
      fontWeight="700"
      fontSize="3.5"
      fill="#0099B5"
      letterSpacing="0.3"
    >
      mada
    </text>
    <text
      x="16"
      y="13"
      textAnchor="middle"
      fontFamily="Arial, sans-serif"
      fontWeight="700"
      fontSize="6"
      fill="#231F20"
    >
      مدى
    </text>
  </svg>
);

const ApplePaySvg = () => (
  <svg viewBox="0 0 32 16" className="h-5 w-auto" aria-label="Apple Pay">
    <rect width="32" height="16" rx="2" fill="#000000" />
    <path
      d="M10.4 5.8c-.3.4-.8.7-1.3.6-.1-.5.2-1 .4-1.3.3-.4.8-.6 1.2-.7.1.5-.1 1-.3 1.4Zm.3.5c-.7-.1-1.3.4-1.6.4-.3 0-.8-.4-1.4-.4-.7 0-1.4.4-1.7 1-.7 1.3-.2 3.2.6 4.3.3.5.7 1 1.3 1 .5 0 .7-.3 1.4-.3s.8.3 1.4.3 1-.5 1.2-1c.4-.6.5-1.1.6-1.2 0-.1-1.1-.5-1.1-1.8 0-1.1.9-1.6 1-1.6-.5-.8-1.3-.9-1.7-.9Z"
      fill="#ffffff"
    />
    <text
      x="22"
      y="11"
      textAnchor="middle"
      fontFamily="-apple-system, BlinkMacSystemFont, Helvetica, Arial, sans-serif"
      fontWeight="500"
      fontSize="6"
      fill="#ffffff"
    >
      Pay
    </text>
  </svg>
);

const TamaraSvg = () => (
  <svg viewBox="0 0 26 16" className="h-5 w-auto" aria-label="Tamara">
    <rect width="26" height="16" rx="2" fill="#000000" />
    <circle cx="10" cy="8" r="3.2" fill="none" stroke="#ffffff" strokeWidth="1.2" />
    <circle cx="15" cy="8" r="3.2" fill="none" stroke="#ffffff" strokeWidth="1.2" />
  </svg>
);

const PaymentRow = ({ value, selected, onSelect, label, logos }) => (
  <label
    className={`m-0 flex items-center justify-between gap-3 px-4 py-3 cursor-pointer bg-white transition-colors ${
      selected ? "ring-2 ring-inset ring-black relative z-10" : ""
    }`}
  >
    <span className="flex items-center gap-3">
      <span className="relative inline-flex items-center justify-center w-4 h-4 rounded-full border-2 border-black flex-shrink-0">
        {selected && <span className="w-2 h-2 bg-black rounded-full" />}
      </span>
      <input
        type="radio"
        name="gateway"
        value={value}
        checked={selected}
        onChange={onSelect}
        className="sr-only"
      />
      <span className="text-[14px] whitespace-nowrap">{label}</span>
    </span>
    <span className="flex items-center gap-1 flex-shrink-0 flex-wrap justify-end">{logos}</span>
  </label>
);

export const MyCart = ({ lang, setLang }) => {
  const { showToast, showErrorToast, showSuccessToast } = useToastMessage();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const isDirect = searchParams.get("direct") === "true";
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const promoCodeTimeoutRef = useRef(null);
  const isRemovingPromoCodeRef = useRef(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [gateway, setGateway] = useState("paytabs"); // 'paytabs' (card) or 'tamara'
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [termsError, setTermsError] = useState(false);
  const [cartDetails, setCartDetails] = useState({
    item_details: {
      bundle_items: [],
      addon_items: [],
    },
    total_amount: 0,
    actual_total_amount: 0,
    tax: 0,
    grand_total: 0,
    total_time: 0,
  });
  const [showModal, setShowModal] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [removedItems, setRemovedItems] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <440);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 440);
  const [phoneError, setPhoneError] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [coupon, setCoupon] = useState(null);
  const [profile, setProfile] = useState({});
  const [tax, setTax] = useState(false);
  const [isBack, setIsBack] = useState(false);
  const [isUploading, setIsUploading] = useState({
    vat_certificate: false,
    national_address_certificate: false,
    trade_license: false,
  });

  const [firstOrder, setFirstOrder] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [profileData, setProfileData] = useState({
    full_name: "",
    email: "",
    phone: "",
    country: "",
  });
  const [profileErrors, setProfileErrors] = useState({});
  const [isUpdatingProfile, setIsUpdatingProfile] = useState(false);

  const [popupMessage, setPopupMessage] = useState(
    lang === "ar"
      ? "هل أنت متأكد من إفراغ السلة؟"
      : "Are you sure you want to empty the cart?"
  );

  const [routeNames, setRouteNames] = useState({
    4: "foodie",
    12: "newbie",
    13: "boutiquer",
    22: "socialite",
  });
  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo (Congo-Brazzaville)",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Democratic Republic of the Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea, North",
    "Korea, South",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar (formerly Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];

  const [billingInfo, setBillingInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    country: "",
    city: "",
    postalCode: "",
    promoCode: "",
    vat_registered: "",
    trn: "",
    is_saudi: "",
    customer_type: "individual",
    vat_certificate: "",
    vat_certificate_name: "",
    national_address_certificate: "",
    national_address_certificate_name: "",
    trade_license: "",
    trade_license_name: "",
    language: "", // Will be set from cart data or location state
  });

  const [error, setError] = useState({});
  const [errors, setErrors] = useState({});

  const colors = {
    12: "#f175ad",
    4: "#1BA56F",
    22: "#00A8C8",
    13: "#f175ad",
  };

  const [themeColor, setThemeColor] = useState("#000");

  useEffect(() => {
    setThemeColor(colors[cartDetails.bundle_id]);
  }, [cartDetails]);

  const getprojects = async () => {
    try {
      const response = await axios.get(`${base_url}/api/order/`, ConfigToken());
      if (response.data) {
        const resProjects = response.data.data.filter(
          (item) => item.order_status != "in_cart"
        );
        if (resProjects.length) {
          setFirstOrder(false);
        } else {
          setFirstOrder(true);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  // const toastMessage = () => {
  //   const message = "Cart updated successfully";

  //   if (toastId) {
  //     toast.dismiss(toastId);
  //   }

  //   toastId = toast(message, {
  //     duration: 3000,
  //     style: {
  //       color: themeColor,
  //       border: `1px solid ${themeColor}`,
  //       fontWeight: "700",
  //       background: "#fff",
  //       boxShadow: "none",
  //       borderRadius: "0px",
  //     },
  //   });
  // };

  useEffect(() => {
    document.documentElement.scrollTo({ top: 0, left: 0 });
    getCartData();
  }, []);

  // Show a toast if the user was bounced back from Tamara's hosted page after
  // a failed or cancelled checkout. The merchant_url query params come from
  // bundldesignback/projects/views/tamara.py initiate_tamara_payment.
  useEffect(() => {
    const tamaraStatus = searchParams.get("tamara");
    if (tamaraStatus === "failed") {
      showErrorToast(
        lang === "ar" ? "فشل الدفع عبر تمارا" : "Tamara payment failed",
        "#D83D99"
      );
    } else if (tamaraStatus === "cancelled") {
      showErrorToast(
        lang === "ar" ? "تم إلغاء الدفع" : "Payment cancelled",
        "#D83D99"
      );
    }
    // Strip the tamara=… params so a back-nav or refresh doesn't replay the toast.
    if (tamaraStatus) {
      const next = new URLSearchParams(searchParams);
      next.delete("tamara");
      next.delete("order");
      setSearchParams(next, { replace: true });
    }
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 440);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
   useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >440);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Recalculate VAT when is_saudi or vat_registered changes
  useEffect(() => {
    // Only recalculate if is_saudi has been set (not empty)
    // Note: We don't include coupon in dependencies to avoid interference when promo code is removed
    if (billingInfo.is_saudi) {
      // Use coupon discount if available, otherwise null (which will use coupon state)
      const discountToUse = coupon && coupon.discount ? coupon.discount : null;
      getTotal(billingInfo.country.trim(), discountToUse, billingInfo);
    }
  }, [billingInfo.is_saudi, billingInfo.vat_registered]);

  const getCartData = async () => {
    try {
      setLoading(true);
      getProfile();

      const response = await axios.get(
        `${base_url}/api/order/cart/`,
        ConfigToken()
      );
      if (response.data) {
        const cartData = response.data;
        let calculatedTotal = 0;
        
        // Calculate bundle price - prefer bundle_price, otherwise calculate from bundle_items
        if (cartData.bundle_price) {
          const bundlePrice = parseFloat(cartData.bundle_price);
          if (!isNaN(bundlePrice) && bundlePrice > 0) {
            // Add language addition (2000 for "Both")
            const languageAddition = (cartData.language === "Both" || location?.state?.selectedLanguage === "Both") ? 2000 : 0;
            // Add illustrations addition (2000 for "illustrations")
            const illustrationsAddition = (cartData.illustrations === "illustrations" || location?.state?.selectedIllustrations === "illustrations") ? 2000 : 0;
            calculatedTotal += bundlePrice + languageAddition + illustrationsAddition;
          }
        } else if (cartData.item_details?.bundle_items && Array.isArray(cartData.item_details.bundle_items) && cartData.item_details.bundle_items.length > 0) {
          // Calculate from bundle_items if bundle_price doesn't exist
          const bundleItemsTotal = cartData.item_details.bundle_items.reduce((sum, item) => {
            if (item.subtotal_price) {
              const subtotal = parseFloat(item.subtotal_price);
              if (!isNaN(subtotal) && subtotal > 0) return sum + subtotal;
            }
            if (item.unit_price && item.qty) {
              const unitPrice = parseFloat(item.unit_price);
              const qty = parseFloat(item.qty);
              if (!isNaN(unitPrice) && !isNaN(qty) && unitPrice > 0 && qty > 0) {
                return sum + (unitPrice * qty);
              }
            }
            return sum;
          }, 0);
          if (bundleItemsTotal > 0) {
            calculatedTotal += bundleItemsTotal;
          }
        }
        
        // Add all addon items
        if (cartData.item_details?.addon_items && Array.isArray(cartData.item_details.addon_items) && cartData.item_details.addon_items.length > 0) {
          const addonTotal = cartData.item_details.addon_items.reduce((sum, item) => {
            if (item.subtotal_price) {
              const subtotal = parseFloat(item.subtotal_price);
              if (!isNaN(subtotal) && subtotal > 0) return sum + subtotal;
            }
            if (item.unit_price && item.qty) {
              const unitPrice = parseFloat(item.unit_price);
              const qty = parseFloat(item.qty);
              if (!isNaN(unitPrice) && !isNaN(qty) && unitPrice > 0 && qty > 0) {
                return sum + (unitPrice * qty);
              }
            }
            return sum;
          }, 0);
          calculatedTotal += addonTotal;
        }
        
        // Ensure calculatedTotal is a valid number and round to 2 decimal places
        let finalTotal = isNaN(calculatedTotal) ? 0 : calculatedTotal;
        // Round to 2 decimal places
        finalTotal = Math.round(finalTotal * 100) / 100;
        
        // Preserve ALL data from response, especially item_details
        const updatedCartDetails = {
          ...cartData,
          actual_total_amount: finalTotal, // Base total before discount
          total_amount: finalTotal, // Will be updated after discount is applied
          tax: cartData.tax || 0,
          grand_total: cartData.grand_total || finalTotal,
        };
        
        // Explicitly preserve item_details structure and filter out empty objects
        if (cartData.item_details) {
          updatedCartDetails.item_details = {
            bundle_items: (cartData.item_details.bundle_items || []).filter(item => item && Object.keys(item).length > 0),
            addon_items: (cartData.item_details.addon_items || []).filter(item => item && Object.keys(item).length > 0),
          };
        } else {
          updatedCartDetails.item_details = {
            bundle_items: [],
            addon_items: [],
          };
        }
        
        setCartDetails(updatedCartDetails);
        setTotalAmount(finalTotal);

        // Populate billingInfo from cart API response if data exists
        const updatedBillingInfo = { ...billingInfo };

        // Split user_name into firstName and lastName if present
        if (cartData.user_name) {
          const nameParts = cartData.user_name.trim().split(" ");
          updatedBillingInfo.firstName = nameParts[0] || "";
          updatedBillingInfo.lastName = nameParts.slice(1).join(" ") || "";
        }

        // Populate other fields if they exist in the response
        if (cartData.phone) updatedBillingInfo.phone = cartData.phone;
        if (cartData.email) updatedBillingInfo.email = cartData.email;
        if (cartData.country) updatedBillingInfo.country = cartData.country;
        if (cartData.city) updatedBillingInfo.city = cartData.city;
        if (cartData.postal_code || cartData.postalCode) {
          updatedBillingInfo.postalCode = cartData.postal_code || cartData.postalCode;
        }
        if (cartData.promo_code) updatedBillingInfo.promoCode = cartData.promo_code;
        if (cartData.vat_registered !== undefined) {
          updatedBillingInfo.vat_registered = cartData.vat_registered === true ? "vat" : "non_vat";
        }
        if (cartData.trn) updatedBillingInfo.trn = cartData.trn;
        if (cartData.is_saudi !== undefined) {
          updatedBillingInfo.is_saudi = cartData.is_saudi === true ? "yes" : "no";
        }
        if (cartData.customer_type) updatedBillingInfo.customer_type = cartData.customer_type;
        if (cartData.vat_certificate) {
          updatedBillingInfo.vat_certificate = cartData.vat_certificate;
          updatedBillingInfo.vat_certificate_name = cartData.vat_certificate_name || "";
        }
        if (cartData.national_address_certificate) {
          updatedBillingInfo.national_address_certificate = cartData.national_address_certificate;
          updatedBillingInfo.national_address_certificate_name = cartData.national_address_certificate_name || "";
        }
        if (cartData.trade_license) {
          updatedBillingInfo.trade_license = cartData.trade_license;
          updatedBillingInfo.trade_license_name = cartData.trade_license_name || "";
        }
        // Set language from cart data or location state (priority: cartData.language > location.state.selectedLanguage)
        if (cartData.language) {
          // Ensure proper capitalization: "Both", "English", "Arabic"
          const languageValue = cartData.language;
          updatedBillingInfo.language = languageValue === "both" ? "Both" : 
                                        languageValue === "english" ? "English" :
                                        languageValue === "arabic" ? "Arabic" : languageValue;
        } else if (location?.state?.selectedLanguage) {
          updatedBillingInfo.language = location.state.selectedLanguage;
        } else {
          // Fallback to UI language if no selection found
          updatedBillingInfo.language = localStorage.getItem("lang") === "ar" ? "Arabic" : "English";
        }

        setBillingInfo(updatedBillingInfo);

        // If promo code exists, validate it and apply discount (only once, not on every render)
        if (cartData.promo_code && cartData.promo_code.trim() !== "") {
          try {
            const promoResponse = await axios.get(
              `${base_url}/api/promocode?promoCode=${cartData.promo_code}`,
              ConfigToken()
            );
            if (promoResponse.status === 200) {
              setCoupon(promoResponse.data);
              // Recalculate totals with discount - getTotal will recalculate from items first, then apply discount
              if (updatedBillingInfo.country && updatedBillingInfo.country.trim()) {
                // Use setTimeout to ensure cartDetails is updated first
                setTimeout(() => {
                  getTotal(updatedBillingInfo.country.trim(), promoResponse.data.discount, updatedBillingInfo);
                }, 100);
              } else {
                // Even if country is not set, apply discount calculation
                setTimeout(() => {
                  getTotal("", promoResponse.data.discount, updatedBillingInfo);
                }, 100);
              }
            }
          } catch (error) {
            // Silently fail - promo code might be invalid
          }
        } else {
          // No promo code - ensure totals are calculated correctly without discount
          setTimeout(() => {
            getTotal(updatedBillingInfo.country?.trim() || "", null, updatedBillingInfo);
          }, 100);
        }
      }
      if (
        response.status === 206 ||
        (response?.data?.item_details?.bundle_items?.length === 0 &&
          response?.data?.item_details?.addon_items.length === 0)
      ) {
        setOpenPopup(true);
        setPopupMessage(
          lang === "ar"
            ? "عربة التسوق فارغة - انقر أدناه للاختيار من بين حزمنا"
            : "Cart Is empty - click below to choose from our bundles"
        );
      }
      if (response.status === 206) {
        setPopupMessage(
          lang === "ar"
            ? "عربة التسوق فارغة - انقر أدناه للاختيار من بين حزمنا"
            : "Cart Is empty - click below to choose from our bundles"
        );
      }
    } catch (e) {
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  const removeItem = async (itemId, itemType) => {
    const existLocalData = JSON.parse(localStorage.getItem("payloads")) || {};
    if (itemType == "bundle") {
      toast.error(
        lang === "ar"
          ? "لا يمكن إزالة عنصر الباقة"
          : `Package Item Cannot removed`,
        {
          position: toast?.POSITION?.TOP_RIGHT,
          toastId: "required-value-toast",
          icon: false,
          style: {
            color: "#D83D99",
            fontWeight: "700",
          },
        }
      );
      return;
    }
    
    setRemovedItems(itemId);
    setLoading(true);

    try {
      // Call API to delete item
      await axios.patch(
        `${base_url}/api/order/cart/`,
        {
          item_to_delete: itemId,
        },
        ConfigToken()
      );

      // Refresh cart data completely - this will recalculate everything correctly
      const cartResponse = await axios.get(
        `${base_url}/api/order/cart/`,
        ConfigToken()
      );
      
      if (cartResponse.data) {
        const cartData = cartResponse.data;
        
        // Update cartDetails with fresh API data (preserve item_details structure)
        // Don't set totals manually - let getTotal calculate everything
        const updatedCartDetails = {
          ...cartData,
        };
        
        if (cartData.item_details) {
          updatedCartDetails.item_details = {
            bundle_items: (cartData.item_details.bundle_items || []).filter(item => item && Object.keys(item).length > 0),
            addon_items: (cartData.item_details.addon_items || []).filter(item => item && Object.keys(item).length > 0),
          };
        } else {
          updatedCartDetails.item_details = {
            bundle_items: [],
            addon_items: [],
          };
        }
        
        // Update localStorage if needed
        if (existLocalData && updatedCartDetails.item_details.addon_items.length > 0) {
          const addonsData = {
            order_name: "Addons",
            item_list: updatedCartDetails.item_details.addon_items.map((item) => ({
              design_id: item.item__id,
              addon_name: item.item_name,
              addon_arabic: item.item__name_arabic,
              category: item?.category,
              total_price: parseFloat(item.subtotal_price || 0),
              item_type: item.item_type,
              unit_price: item.unit_price?.toFixed(2) || String(item.unit_price),
              unit_time: item.unit_time?.toFixed(2) || String(item.unit_time),
              qty: item.qty?.toString() || String(item.qty),
            })),
          };
          const updatedPayloads = {
            ...existLocalData,
            addons: addonsData,
          };
          localStorage.setItem("payloads", JSON.stringify(updatedPayloads));
        } else if (existLocalData && updatedCartDetails.item_details.addon_items.length === 0) {
          // Clear addons from localStorage if no addons remain
          const updatedPayloads = {
            ...existLocalData,
            addons: { item_list: [], total_price: 0, total_time: 0 },
          };
          localStorage.setItem("payloads", JSON.stringify(updatedPayloads));
        }
        
        // Update cart details, then let getTotal calculate all totals correctly
        setCartDetails(updatedCartDetails);
        
        // getTotal will recalculate everything from the updated cartDetails and apply discount/tax correctly
        // Use setTimeout to ensure React has processed the state update
        setTimeout(() => {
          getTotal(billingInfo.country?.trim() || "", coupon?.discount || null, billingInfo);
          setLoading(false);
        }, 150);
      }
    } catch (error) {
      console.error("Error removing item:", error);
      // On error, refresh cart data to restore correct state
      getCartData();
      setLoading(false);
    }
  };

  const getBundleRoute = () => {
    // Only resolve bundle route if cart data was loaded from API (has bundl_english key)
    if (!("bundl_english" in cartDetails)) return "/";

    const bundlEnglish = cartDetails.bundl_english;

    // Named bundle (Newbie, Foodie, Socialite, Boutiquer)
    const routeName = convertBundlEnglishToRoute(bundlEnglish);
    if (routeName) return `/bundldetail/${routeName}`;

    // Custom bundle: bundl_english is empty string
    if (!bundlEnglish || bundlEnglish === "") return "/custombundl";

    return "/";
  };

  const emptyCart = async () => {
    // Determine bundle route before clearing
    const bundleRoute = getBundleRoute();

    // Clear localStorage payloads
    localStorage.removeItem("payloads");

    // Delete cart from API if authenticated
    const tokenConfig = ConfigToken();
    const isAuthenticated =
      tokenConfig.headers?.authorization &&
      tokenConfig.headers.authorization !== "Token null";

    if (isAuthenticated) {
      try {
        await axios.delete(`${base_url}/api/order/cart/`, ConfigToken());
      } catch (error) {
        console.error("Error deleting cart:", error);
        // Still proceed even if API call fails
      }
    }

    // Redirect to the initially chosen bundle
    navigate(bundleRoute);
  };

  const getTotal = (countryValue, discount = null, billingInfoOverride = null) => {
    setCartDetails((prevCartDetails) => {
      // Don't proceed if cartDetails is not initialized
      if (!prevCartDetails || !prevCartDetails.item_details) {
        return prevCartDetails;
      }
      
      const updatedItemDetails = { ...prevCartDetails.item_details };
      
      // ALWAYS recalculate total from items first (don't use stored values)
      let baseTotal = 0;
      
      // Calculate bundle price
      if (prevCartDetails.bundle_price) {
        const bundlePrice = parseFloat(prevCartDetails.bundle_price);
        if (!isNaN(bundlePrice) && bundlePrice > 0) {
          // Add language addition (2000 for "Both")
          const languageAddition = (prevCartDetails.language === "Both" || location?.state?.selectedLanguage === "Both") ? 2000 : 0;
          // Add illustrations addition (2000 for "illustrations")
          const illustrationsAddition = (prevCartDetails.illustrations === "illustrations" || location?.state?.selectedIllustrations === "illustrations") ? 2000 : 0;
          baseTotal += bundlePrice + languageAddition + illustrationsAddition;
        }
      } else if (updatedItemDetails.bundle_items && Array.isArray(updatedItemDetails.bundle_items) && updatedItemDetails.bundle_items.length > 0) {
        const bundleItemsTotal = updatedItemDetails.bundle_items.reduce((sum, item) => {
          if (item.subtotal_price) {
            const subtotal = parseFloat(item.subtotal_price);
            if (!isNaN(subtotal) && subtotal > 0) return sum + subtotal;
          }
          if (item.unit_price && item.qty) {
            const unitPrice = parseFloat(item.unit_price);
            const qty = parseFloat(item.qty);
            if (!isNaN(unitPrice) && !isNaN(qty) && unitPrice > 0 && qty > 0) {
              return sum + (unitPrice * qty);
            }
          }
          return sum;
        }, 0);
        if (bundleItemsTotal > 0) {
          baseTotal += bundleItemsTotal;
        }
      }
      
      // Calculate addon items total
      if (updatedItemDetails.addon_items && Array.isArray(updatedItemDetails.addon_items) && updatedItemDetails.addon_items.length > 0) {
        const addonTotal = updatedItemDetails.addon_items.reduce((sum, item) => {
          if (item.subtotal_price) {
            const subtotal = parseFloat(item.subtotal_price);
            if (!isNaN(subtotal) && subtotal > 0) return sum + subtotal;
          }
          if (item.unit_price && item.qty) {
            const unitPrice = parseFloat(item.unit_price);
            const qty = parseFloat(item.qty);
            if (!isNaN(unitPrice) && !isNaN(qty) && unitPrice > 0 && qty > 0) {
              return sum + (unitPrice * qty);
            }
          }
          return sum;
        }, 0);
        baseTotal += addonTotal;
      }
      
      // Ensure baseTotal is valid and round to 2 decimal places
      if (isNaN(baseTotal)) {
        baseTotal = 0;
      } else {
        // Round to 2 decimal places to avoid floating point issues
        baseTotal = Math.round(baseTotal * 100) / 100;
      }
      
      // Store the base total (before discount) as actual_total_amount
      const actualTotalAmount = baseTotal;
      
      // NOW apply discount if provided
      let discountedAmount = baseTotal;
      
      // Priority order:
      // 1. If discount is explicitly false OR we're removing promo code, NO discount - ignore coupon completely
      // 2. If discount is a number, use that discount value
      // 3. If discount is null/undefined, use coupon if available
      
      if (discount === false || isRemovingPromoCodeRef.current) {
        // Explicitly no discount - promo code was removed, ignore coupon state completely
        discountedAmount = baseTotal;
      } else if (discount !== null && discount !== undefined && discount !== false && typeof discount === 'number') {
        // Discount is explicitly provided as a number
        const discountValue = parseFloat(discount);
        if (!isNaN(discountValue) && discountValue > 0) {
          discountedAmount = baseTotal - (baseTotal / 100) * discountValue;
        } else {
          discountedAmount = baseTotal;
        }
      } else if (discount === null || discount === undefined) {
        // No explicit discount parameter - use coupon if available
        if (coupon && coupon.discount) {
          const discountValue = parseFloat(coupon.discount);
          if (!isNaN(discountValue) && discountValue > 0) {
            discountedAmount = baseTotal - (baseTotal / 100) * discountValue;
          } else {
            discountedAmount = baseTotal;
          }
        } else {
          // No coupon, no discount
          discountedAmount = baseTotal;
        }
      }
      
      // Ensure discountedAmount is valid and round to 2 decimal places
      if (isNaN(discountedAmount) || discountedAmount < 0) {
        discountedAmount = 0;
      } else {
        // Round to 2 decimal places to avoid floating point issues
        discountedAmount = Math.round(discountedAmount * 100) / 100;
      }
      
      let updatedTotalTime = prevCartDetails.total_time || 0;
      
      // Calculate tax based on discounted amount
      let updatedTax = 0;
      let updatedTaxTreatment = 0;
      const currentBillingInfo = billingInfoOverride || billingInfo;
      if (currentBillingInfo.is_saudi === "yes") {
        updatedTax = discountedAmount * 0.15; // VAT is 15% of discounted amount
        // Round tax to 2 decimal places
        updatedTax = Math.round(updatedTax * 100) / 100;
        updatedTaxTreatment = 15;
      }

      const updatedGrandTotal = parseFloat(discountedAmount) + updatedTax;
      // Round grand total to 2 decimal places
      const finalGrandTotal = isNaN(updatedGrandTotal) ? discountedAmount : Math.round(updatedGrandTotal * 100) / 100;
      
      // Ensure all values are valid numbers (already rounded to 2 decimals)
      const finalTotalAmount = isNaN(discountedAmount) ? 0 : discountedAmount;
      const finalTax = isNaN(updatedTax) ? 0 : updatedTax;

      return {
        ...prevCartDetails,
        item_details: updatedItemDetails,
        total_amount: finalTotalAmount, // Display amount (after discount)
        actual_total_amount: actualTotalAmount, // Base amount (before discount)
        total_time: updatedTotalTime || 0,
        tax: finalTax,
        tax_treatment: updatedTaxTreatment,
        grand_total: finalGrandTotal,
      };
    });
  };

  const validateFields = () => {
    let newErrors = {};

    if (!billingInfo.firstName.trim()) {
      setError({
        firstName:
          lang === "ar"
            ? "حقل الاسم الأول فارغ"
            : "Your first name field is empty.",
      });
      return false;
    } else if (/\d/.test(billingInfo.firstName)) {
      setError({ firstName: "First Name should not contain numbers." });
      return false;
    }
    if (!billingInfo.lastName.trim()) {
      setError({
        lastName:
          lang === "ar"
            ? "حقل اسم العائلة فارغ"
            : "Your last name field is empty.",
      });
      return false;
    } else if (/\d/.test(billingInfo.lastName)) {
      setError({ lastName: "Last Name should not contain numbers." });
      return false;
    }

    if (!billingInfo.email.trim()) {
      setError({
        email:
          lang === "ar"
            ? "حقل البريد الإلكتروني فارغ"
            : "Your email field is empty",
      });
      return false;
    } else if (!/^[\w-.]+@[\w-]+\.[a-z]{2,4}$/i.test(billingInfo.email)) {
      setError({
        email:
          lang === "ar"
            ? "تنسيق البريد الإلكتروني غير صالح"
            : "Invalid email format",
      });
      return false;
    }
    if (!billingInfo.phone.trim()) {
      setError({
        phone:
          lang === "ar"
            ? "حقل رقم الهاتف فارغ"
            : "Your phone number field is empty.",
      });
      return false;
    }

    if (!billingInfo.country.trim()) {
      setError({
        country:
          lang === "ar" ? "حقل الدولة فارغ" : "Your country field is empty.",
      });
      return false;
    }
    if (!billingInfo.city.trim()) {
      setError({
        city: lang === "ar" ? "حقل المدينة فارغ" : "Your city field is empty.",
      });
      return false;
    }
    if (!billingInfo.is_saudi.trim()) {
      setError({
        is_saudi:
          lang === "ar"
            ? "حقل هل أنت سعودي فارغ"
            : "Please select if you are Saudi.",
      });
      return false;
    }
    if (billingInfo.is_saudi === "yes") {
      if (!billingInfo.customer_type.trim()) {
        setError({
          customer_type:
            lang === "ar"
              ? "حقل نوع العميل فارغ"
              : "Your customer type field is empty.",
        });
        return false;
      }
      if (!billingInfo.vat_registered.trim()) {
        setError({
          vat_registered:
            lang === "ar"
              ? "حقل التسجيل الضريبي فارغ"
              : "Your tax treatment field is empty.",
        });
        return false;
      }
      if (!billingInfo.trn.trim() && billingInfo?.vat_registered === "vat") {
        setError({
          trn:
            lang === "ar"
              ? "حقل الرقم الضريبي فارغ"
              : "Your TRN Number field is empty.",
        });
        return false;
      }
      if (billingInfo.customer_type === "company" && billingInfo.vat_registered === "vat") {
        if (!billingInfo.vat_certificate.trim()) {
          setError({
            vat_certificate:
              lang === "ar"
                ? "يرجى رفع شهادة ضريبة القيمة المضافة"
                : "Please upload VAT Certificate.",
          });
          return false;
        }
        if (!billingInfo.national_address_certificate.trim()) {
          setError({
            national_address_certificate:
              lang === "ar"
                ? "يرجى رفع شهادة العنوان الوطني"
                : "Please upload National Address Certificate.",
          });
          return false;
        }
        if (!billingInfo.trade_license.trim()) {
          setError({
            trade_license:
              lang === "ar"
                ? "يرجى رفع الرخصة التجارية"
                : "Please upload Trade License.",
          });
          return false;
        }
      }
    }
    // if (!billingInfo.postalCode.trim()) {
    //   setError({
    //     postalCode:
    //       lang === "ar"
    //         ? "حقل الرمز البريدي فارغ"
    //         : "Your postal code field is empty.",
    //   });
    //   return false;
    // } else if (!/^[0-9]$/.test(billingInfo.postalCode)) {
    //   setError({
    //     postalCode:
    //       lang === "ar"
    //         ? "خمسة أرقام يجب أن يكون الرمز البريدي من رقمين إلى "
    //         : "Your postal code must be 4 or 5 digits.",
    //   });
    //   return false;
    // }
      if (billingInfo.postalCode.trim() && !/^\d+$/.test(billingInfo.postalCode)) {
          setError({
              postalCode:
                  lang === "ar"
                      ? "يجب أن يحتوي الرمز البريدي على أرقام فقط."
                      : "Your postal code must contain only numbers.",
          });
          return false;
      }

    setError(newErrors);

    return true;
  };
  const getProfile = async () => {
    try {
      const response = await axios.get(`${base_url}/api/profile/`, ConfigToken());
      if (response.data) {
        setProfile(response.data);
        setProfileData({
          full_name: response.data.full_name || "",
          email: response.data.email || "",
          phone: response.data.phone || "",
          country: response.data.country || "",
        });
        // Split full_name into firstName and lastName for billing form
        const nameParts = (response.data.full_name || "").trim().split(" ");
        const firstName = nameParts[0] || "";
        const lastName = nameParts.slice(1).join(" ") || "";
        setBillingInfo((prevState) => ({
          ...prevState,
          firstName: firstName || prevState.firstName,
          lastName: lastName || prevState.lastName,
          email: response.data.email || prevState.email,
          phone: response.data.phone || prevState.phone,
          country: response.data.country || prevState.country,
        }));
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
    return null;
  };

  const TermsModal = () => {
    if (!showTermsModal) return null;

    return (
      <div className="fixed inset-0 z-[1001] flex items-center justify-center bg-black bg-opacity-50 font-['Inter']">
        <div className="bg-white p-8 w-[90%] max-w-[600px] relative border-black border-[1px]">
          <button
            className="absolute top-4 right-4"
            onClick={() => setShowTermsModal(false)}
          >
            <CloseIcon />
          </button>
          <h2 className="text-2xl font-bold mb-6 text-center uppercase">
            {lang === "ar" ? "الشروط والأحكام" : "Terms & Conditions"}
          </h2>
          <div
            className={`mb-6 text-gray-800 space-y-4 ${
              lang === "ar" ? "text-right" : "text-left"
            }`}
            dir={lang === "ar" ? "rtl" : "ltr"}
          >
            {lang === "ar" ? (
              <>
                <div className="flex gap-2">
                  <span className="font-bold ml-1">·</span>
                  <div>
                    <p className="mb-0">يشمل كل تصميم تعديلًا واحدًا مجانيًا.</p>
                    <p className="mb-0">
                      في حال الرغبة بإجراء تعديلات إضافية، يمكن طلبها مقابل رسوم
                      .
                    </p>
                  </div>
                </div>
                <div className="flex gap-2">
                  <span className="font-bold ml-1">·</span>
                  <p className="mb-0">
                    الية العميل لاتشمل اجتماعات. يتم التواصل والمتابعة حصرًا عبر
                    تطبيق واتساب
                  </p>
                </div>
                <div className="flex gap-2">
                  <span className="font-bold ml-1">·</span>
                  <p className="mb-0">
                    نظرًا لأن جميع التصاميم مُنفذة حسب الطلب وبشكل مخصص، لا يمكن
                    توفير استرجاع أو استبدال التصاميم
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className="flex gap-2">
                  <span className="font-bold mr-1">·</span>
                  <div>
                    <p className="mb-0">Each design includes one complimentary revision.</p>
                    <p className="mb-0">
                      Any additional revisions may be requested for an
                      additional fee.
                    </p>
                  </div>
                </div>
                <div className="flex gap-2">
                  <span className="font-bold mr-1">·</span>
                  <p className="mb-0">
                    Orders do not include meetings. All communication and
                    follow-ups will be conducted exclusively via WhatsApp.
                  </p>
                </div>
                <div className="flex gap-2">
                  <span className="font-bold mr-1">·</span>
                  <p className="mb-0">
                    As all designs are custom-made and created upon request,
                    refunds or exchanges are not available.
                  </p>
                </div>
              </>
            )}
          </div>
          <div className="text-center pt-2">
            <a
              href="/terms-and-conditions"
              target="_blank"
              rel="noreferrer"
              className="underline text-[#D83D99] font-bold"
            >
              {lang === "ar" ? "إقرأ المزيد" : "Read more"}
            </a>
          </div>
          <div className="flex justify-center mt-6">
            <button
              onClick={() => {
                setAgreedToTerms(true);
                setTermsError(false);
                setShowTermsModal(false);
              }}
              className="px-8 py-2 bg-[#0BA6C4] text-white rounded-none uppercase font-bold"
            >
              {lang === "ar" ? "أوافق" : "I Agree"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const handleProfileUpdate = async (e) => {
      e.preventDefault();
      let errors = {};
      if (!profileData.full_name)
        errors.full_name =
          lang === "ar" ? "الاسم الكامل مطلوب" : "Full Name is required";
      if (!profileData.email)
        errors.email =
          lang === "ar"
            ? "البريد الإلكتروني مطلوب"
            : "Email is required";
      else if (!/\S+@\S+\.\S+/.test(profileData.email))
        errors.email =
          lang === "ar" ? "إيميل غير صالح" : "Invalid email";
      else if (profileData.email.includes("@privaterelay.appleid.com"))
        errors.email =
          lang === "ar"
            ? "يرجى تحديث ايميل ابل الخاص بك"
            : "Please update your Apple relay email";
      if (!profileData.phone)
        errors.phone =
          lang === "ar" ? "رقم الهاتف مطلوب" : "Phone number is required";

      if (Object.keys(errors).length > 0) {
        setProfileErrors(errors);
        return;
      }

      setIsUpdatingProfile(true);
      try {
        const response = await axios.post(
          `${base_url}/api/profile/`,
          profileData,
          ConfigToken()
        );
        if (response.status === 200) {
          showSuccessToast(
            lang === "ar" ? "تم تحديث الملف الشخصي" : "Profile updated successfully"
          );
          setShowProfileModal(false);
          // Proceed to payment flow again
          handlePayment(e, true);
        }
      } catch (err) {
        console.error("Profile update error:", err);
        showErrorToast(
          lang === "ar"
            ? "فشل في تحديث الملف الشخصي"
            : "Failed to update profile"
        );
    } finally {
      setIsUpdatingProfile(false);
    }
  };

  const profileCompletionModalContent = showProfileModal ? (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-50 font-['Inter']">
        <div className="bg-white p-8 w-[90%] max-w-[500px] relative">
          <button
            className="absolute top-4 right-4"
            onClick={() => {
              setShowProfileModal(false);
              setPaymentLoading(false);
            }}
          >
            <CloseIcon />
          </button>
          <h2 className="text-2xl font-bold mb-6 text-center uppercase">
            {lang === "ar" ? "أكمل ملفك الشخصي" : "Complete Your Profile"}
          </h2>
          <p className="mb-6 text-gray-600 text-center">
            {lang === "ar"
              ? "يرجى تقديم تفاصيلك للمتابعة إلى الدفع."
              : "Please provide your details to proceed to payment."}
          </p>
          <form onSubmit={handleProfileUpdate}>
            <div className="mb-4">
              <label className="block mb-1 font-semibold">
                {lang === "ar" ? "الاسم الكامل" : "Full Name"}
              </label>
              <input
                type="text"
                className={`w-full border p-2 rounded-none outline-none ${
                  profileErrors.full_name ? "border-red-500" : "border-black"
                }`}
                value={profileData.full_name}
                onChange={(e) =>
                  setProfileData({ ...profileData, full_name: e.target.value })
                }
              />
              {profileErrors.full_name && (
                <p className="text-red-500 text-sm mt-1">
                  {profileErrors.full_name}
                </p>
              )}
            </div>
            <div className="mb-4">
              <label className="block mb-1 font-semibold">
                {lang === "ar" ? "البريد الإلكتروني" : "Email"}
              </label>
              <input
                type="email"
                className={`w-full border p-2 rounded-none outline-none ${
                  profileErrors.email ? "border-red-500" : "border-black"
                }`}
                value={profileData.email}
                onChange={(e) =>
                  setProfileData({ ...profileData, email: e.target.value })
                }
              />
              {profileErrors.email && (
                <p className="text-red-500 text-sm mt-1">
                  {profileErrors.email}
                </p>
              )}
            </div>
            <div className="mb-6">
              <label className="block mb-1 font-semibold">
                {lang === "ar" ? "رقم الهاتف" : "Phone Number"}
              </label>
              <PhoneInput
                country={"sa"}
                enableSearch={true}
                value={profileData.phone}
                onChange={(phone) =>
                  setProfileData({ ...profileData, phone: `+${phone}` })
                }
                containerClass="!w-full"
                inputClass="!w-full !h-[42px] !border-black !rounded-none !outline-none"
                buttonClass="!border-black !rounded-none"
              />
              {profileErrors.phone && (
                <p className="text-red-500 text-sm mt-1">
                  {profileErrors.phone}
                </p>
              )}
            </div>
            <button
              type="submit"
              disabled={isUpdatingProfile}
              className="w-full bg-black text-white py-3 font-bold hover:bg-gray-800 uppercase"
            >
              {isUpdatingProfile ? (
                <ClipLoader color={"#FFFFFF"} size={20} />
              ) : lang === "ar" ? (
                "حفظ والمتابعة"
              ) : (
                "Save and Proceed"
              )}
            </button>
          </form>
        </div>
      </div>
  ) : null;

  // const handlePayment = async (e) => {
  //   e.preventDefault();
  //   ;
  //   setPaymentLoading(true);
  //   if (validateFields()) {
  //     getprojects();
  //     if(firstOrder === true){

  //     }
  //     if (
  //       (cartDetails.total_amount >= 4800 &&
  //         !firstOrder &&
  //         cartDetails.bundl_english === "The Newbie") ||
  //       (cartDetails.total_amount >= 800 &&
  //         cartDetails.bundl_english === "" &&
  //         !firstOrder) ||
  //       cartDetails.bundl_english === "The Socialite" ||
  //       cartDetails.bundl_english === "The Boutiquer" ||
  //       cartDetails.bundl_english === "The Foodie"
  //     ) {
  //       if (phoneError == false) {
  //         try {
  //           const formData = {
  //             ...billingInfo,
  //             user_name: billingInfo.firstName + " " + billingInfo.lastName,
  //             phone: billingInfo.phone,
  //             promo_code: billingInfo.promoCode,
  //             total_amount: cartDetails.total_amount,
  //             total_time: cartDetails.total_time,
  //             grand_total: cartDetails.grand_total,
  //             tax_treatment: cartDetails.tax_treatment,
  //             tax: cartDetails.tax,
  //             items_to_delete: removedItems,
  //             vat_registered:
  //               billingInfo?.vat_registered === "vat" ? true : false,
  //             trn:
  //               billingInfo?.vat_registered === "non_vat"
  //                 ? null
  //                 : billingInfo?.trn,
  //           };
  //           const response = await axios.put(
  //             `${base_url}/api/order/cart/?initiate=True`,
  //             formData,
  //             ConfigToken()
  //           );
  //           if (response.data) {
  //             window.location.href = response.data.data.redirect_url;
  //           }
  //           // navigate('/dashboard', { state: { reDirect: true} });
  //           console.log("Payment successful:", response.data);
  //         } catch (error) {
  //           console.error("Payment error:", error);
  //         } finally {
  //           setPaymentLoading(false);
  //         }
  //       }
  //     } else {
  //       showErrorToast(
  //         lang === "ar"
  //           ? "الأدنى للطلب يجب أن يكون 4,880"
  //           : `Minimum order amount should be ${
  //               cartDetails.bundl_english === "The Newbie" ? 4880 : 800
  //             }`,
  //         cartDetails.bundl_english === "The Newbie" ? "#D83D99" : "#1BA56F"
  //       );
  //       window.scrollTo({
  //         top: 0,
  //         behavior: "smooth",
  //       });
  //       setPaymentLoading(false);
  //     }
  //   } else {
  //     window.scrollTo({
  //       top: 0,
  //       behavior: "smooth",
  //     });
  //     setPaymentLoading(false);
  //   }
  // };

  // Validation function for Brand Identity pricing
  const validateBrandIdentityPricing = () => {
    // Check if cart contains Brand Identity item
    const brandIdentityItem = cartDetails?.item_details?.bundle_items?.find(
      (item) => item?.item_name && item.item_name.includes("Brand Identity")
    );

    if (!brandIdentityItem) {
      // No Brand Identity in cart, validation passes
      return { isValid: true };
    }

    // Determine if illustrations are selected
    const hasIllustrations =
      cartDetails?.illustrations === "illustrations" ||
      location?.state?.selectedIllustrations === "illustrations";

    // Calculate expected price
    const expectedPrice = hasIllustrations ? 6880 : 4880;

    // Calculate actual Brand Identity price
    // Base bundle price
    const basePrice = parseFloat(cartDetails?.bundle_price || 0);
    
    // Language addition (+2000 for "Both")
    const languageAddition =
      cartDetails?.language === "Both" ||
      location?.state?.selectedLanguage === "Both"
        ? 2000
        : 0;

    // Illustrations addition (+2000 for "illustrations")
    const illustrationsAddition = hasIllustrations ? 2000 : 0;

    // Calculate add-on items total
    let addonTotal = 0;
    if (cartDetails?.item_details?.addon_items && Array.isArray(cartDetails.item_details.addon_items) && cartDetails.item_details.addon_items.length > 0) {
      addonTotal = cartDetails.item_details.addon_items.reduce((sum, item) => {
        if (item.subtotal_price) {
          const subtotal = parseFloat(item.subtotal_price);
          if (!isNaN(subtotal) && subtotal > 0) return sum + subtotal;
        }
        if (item.unit_price && item.qty) {
          const unitPrice = parseFloat(item.unit_price);
          const qty = parseFloat(item.qty);
          if (!isNaN(unitPrice) && !isNaN(qty) && unitPrice > 0 && qty > 0) {
            return sum + (unitPrice * qty);
          }
        }
        return sum;
      }, 0);
    }

    // Total actual price (bundle + language + illustrations + addons)
    const actualPrice = basePrice + languageAddition + illustrationsAddition + addonTotal;

    // Compare with expected price (allow small rounding differences)
    const isValid = actualPrice >= expectedPrice; // Allow 1 SAR difference for rounding

    if (!isValid) {
      return {
        isValid: false,
        expectedPrice,
        actualPrice,
        hasIllustrations,
      };
    }

    return { isValid: true };
  };

  const handlePayment = async (e, forceProceed = false) => {
    e.preventDefault();

    if (!agreedToTerms) {
      setTermsError(true);
      setShowTermsModal(true);
      return;
    }

    setPaymentLoading(true);

    // Fetch profile for completion check and is_new_user (Brand Identity validation)
    const currentProfile = await getProfile();

    if (!forceProceed) {
      // Check profile completion first
      if (currentProfile) {
        const isMissingInfo =
          !currentProfile.full_name ||
          !currentProfile.email ||
          !currentProfile.phone;
        const isAppleRelay =
          currentProfile.email &&
          currentProfile.email.includes("@privaterelay.appleid.com");

        if (isMissingInfo || isAppleRelay) {
          setShowProfileModal(true);
          setPaymentLoading(false);
          return;
        }
      }
    }

    if (validateFields()) {
      // Validate Brand Identity pricing only for new users (skip if promo code is applied)
      const hasPromoCode = billingInfo.promoCode && billingInfo.promoCode.trim() !== "";
      const isNewUser = currentProfile?.is_new_user !== false;
      if (!hasPromoCode && isNewUser) {
        const brandIdentityValidation = validateBrandIdentityPricing();
        if (!brandIdentityValidation.isValid) {
          // Determine if illustrations are selected
          const hasIllustrations =
            cartDetails?.illustrations === "illustrations" ||
            location?.state?.selectedIllustrations === "illustrations";
          
          // Set error message based on illustrations and language
          let errorMessage;
          if (hasIllustrations) {
            errorMessage = lang === "ar"
              ? "الحد الادنى لتصميم الهوية البصرية مع رسمات 6880 ريال"
              : "Minimum Order for brand identity with illustrations is 6880 SAR";
          } else {
            errorMessage = lang === "ar"
              ? "الحد الادنى لتصميم الهوية البصرية 4880 ريال"
              : "Minimum Order for brand identity is 4880 SAR";
          }
          
          showErrorToast(errorMessage, "#D83D99");
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          setPaymentLoading(false);
          return;
        }
      }

      const response = await axios.get(`${base_url}/api/order/`, ConfigToken());
      if (response.data) {
        const resProjects = response.data.data.filter(
          (item) => item.order_status != "in_cart"
        );
        if (resProjects.length === 0) {
          // cartDetails.tax
          // If promo code exists, skip minimum payment checks
          const hasPromoCode = billingInfo.promoCode && billingInfo.promoCode.trim() !== "";
          const hasIllustrations =
            cartDetails?.illustrations === "illustrations" ||
            location?.state?.selectedIllustrations === "illustrations";
          const minNewbie = hasIllustrations ? 6880 : 4880;
          // Brand Identity min order only applies to new users
          const isNewUser = currentProfile?.is_new_user !== false;

          const meetsMinimumRequirement = hasPromoCode
            ? // With promo code: only check bundl_english values
              (cartDetails.bundl_english === "The Newbie" ||
                cartDetails.bundl_english === "" ||
                cartDetails.bundl_english === "The Socialite" ||
                cartDetails.bundl_english === "The Boutiquer" ||
                cartDetails.bundl_english === "The Foodie")
            : // Without promo code: check minimum amounts
              ((cartDetails.bundl_english === "The Newbie" &&
                (!isNewUser || cartDetails.total_amount >= minNewbie)) ||
                (cartDetails.total_amount >= 800 &&
                  cartDetails.bundl_english === "") ||
                cartDetails.bundl_english === "The Socialite" ||
                cartDetails.bundl_english === "The Boutiquer" ||
                cartDetails.bundl_english === "The Foodie");
          
          if (meetsMinimumRequirement) {
            if (phoneError == false) {
              try {
                const formData = {
                  ...billingInfo,
                  user_name: billingInfo.firstName + " " + billingInfo.lastName,
                  phone: billingInfo.phone,
                  promo_code: billingInfo.promoCode,
                  total_amount: cartDetails.total_amount,
                  total_time: cartDetails.total_time,
                  grand_total: cartDetails.grand_total,
                  tax_treatment: cartDetails.tax_treatment,
                  tax: cartDetails.tax,
                  items_to_delete: removedItems,
                  vat_registered:
                    billingInfo?.vat_registered === "vat" ? true : false,
                  trn:
                    billingInfo?.vat_registered === "non_vat"
                      ? null
                      : billingInfo?.trn,
                };
                const response = await axios.put(
                  `${base_url}/api/order/cart/?initiate=True&gateway=${gateway}`,
                  formData,
                  ConfigToken()
                );
                if (response.data?.data?.redirect_url) {
                  window.location.href = response.data.data.redirect_url;
                } else if (response.data?.data?.error) {
                  showErrorToast(response.data.data.error, "#D83D99");
                  setPaymentLoading(false);
                }
                // navigate('/dashboard', { state: { reDirect: true} });
                console.log("Payment successful:", response.data);
              } catch (error) {
                console.error("Payment error:", error);
                // Handle 400 error with error message from API
                if (error.response?.status === 400 && error.response?.data?.total_amount) {
                  showErrorToast(error.response.data.total_amount, "#D83D99");
                } else {
                  // Generic error message
                  showErrorToast(
                    lang === "ar" ? "حدث خطأ أثناء معالجة الدفع" : "An error occurred while processing payment",
                    "#D83D99"
                  );
                }
                setPaymentLoading(false);
              }
            }
          } else {
            // Only show minimum amount error if no promo code is present
            if (!hasPromoCode) {
              showErrorToast(
                lang === "ar"
                  ? (cartDetails.bundl_english === "The Newbie" && hasIllustrations
                    ? "الحد الادنى لتصميم الهوية البصرية مع رسمات 6880 ريال"
                    : `الأدنى للطلب يجب أن يكون ${
                        cartDetails.bundl_english === "The Newbie" ? "4,880" : "800"
                      }`)
                  : (cartDetails.bundl_english === "The Newbie" && hasIllustrations
                    ? "Minimum Order for brand identity with illustrations is 6880 SAR"
                    : `Minimum order amount should be ${
                        cartDetails.bundl_english === "The Newbie" ? 4880 : 800
                      }`),
                cartDetails.bundl_english === "The Newbie" ? "#D83D99" : "#1BA56F"
              );
            } else {
              setPaymentLoading(false);
            }
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            setPaymentLoading(false);
          }
        } else {
          try {
            const formData = {
              ...billingInfo,
              user_name: billingInfo.firstName + " " + billingInfo.lastName,
              phone: billingInfo.phone,
              promo_code: billingInfo.promoCode,
              total_amount: cartDetails.total_amount,
              total_time: cartDetails.total_time,
              grand_total: cartDetails.grand_total,
              tax_treatment: cartDetails.tax_treatment,
              tax: cartDetails.tax,
              items_to_delete: removedItems,
              vat_registered:
                billingInfo?.vat_registered === "vat" ? true : false,
              trn:
                billingInfo?.vat_registered === "non_vat"
                  ? null
                  : billingInfo?.trn,
            };
            const response = await axios.put(
              `${base_url}/api/order/cart/?initiate=True&gateway=${gateway}`,
              formData,
              ConfigToken()
            );
            if (response.data?.data?.redirect_url) {
              window.location.href = response.data.data.redirect_url;
            } else if (response.data?.data?.error) {
              showErrorToast(response.data.data.error, "#D83D99");
              setPaymentLoading(false);
            }
            // navigate('/dashboard', { state: { reDirect: true} });
            console.log("Payment successful:", response.data);
          } catch (error) {
            console.error("Payment error:", error);
            // Handle 400 error with error message from API
            if (error.response?.status === 400 && error.response?.data?.total_amount) {
              showErrorToast(error.response.data.total_amount, "#D83D99");
            } else {
              // Generic error message
              showErrorToast(
                lang === "ar" ? "حدث خطأ أثناء معالجة الدفع" : "An error occurred while processing payment",
                "#D83D99"
              );
            }
            setPaymentLoading(false);
          }
        }
      } else {
        if (phoneError == false) {
          try {
            const formData = {
              ...billingInfo,
              user_name: billingInfo.firstName + " " + billingInfo.lastName,
              phone: billingInfo.phone,
              promo_code: billingInfo.promoCode,
              total_amount: cartDetails.total_amount,
              total_time: cartDetails.total_time,
              grand_total: cartDetails.grand_total,
              tax_treatment: cartDetails.tax_treatment,
              tax: cartDetails.tax,
              items_to_delete: removedItems,
              vat_registered:
                billingInfo?.vat_registered === "vat" ? true : false,
              trn:
                billingInfo?.vat_registered === "non_vat"
                  ? null
                  : billingInfo?.trn,
            };
            const response = await axios.put(
              `${base_url}/api/order/cart/?initiate=True&gateway=${gateway}`,
              formData,
              ConfigToken()
            );
            if (response.data?.data?.redirect_url) {
              window.location.href = response.data.data.redirect_url;
            } else if (response.data?.data?.error) {
              showErrorToast(response.data.data.error, "#D83D99");
              setPaymentLoading(false);
            }
            // navigate('/dashboard', { state: { reDirect: true} });
            console.log("Payment successful:", response.data);
          } catch (error) {
            console.error("Payment error:", error);
            // Handle 400 error with error message from API
            if (error.response?.status === 400 && error.response?.data?.total_amount) {
              showErrorToast(error.response.data.total_amount, "#D83D99");
            } else {
              // Generic error message
              showErrorToast(
                lang === "ar" ? "حدث خطأ أثناء معالجة الدفع" : "An error occurred while processing payment",
                "#D83D99"
              );
            }
            setPaymentLoading(false);
          }
        }
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      setPaymentLoading(false);
    }
  };

  const handleBillingChange = (e) => {
    const { name, value } = e.target;
    if (name === "vat_registered") {
      if (value === "vat") {
        setTax(true);
      } else {
        setTax(false);
      }
      // Recalculate VAT when VAT registered status changes
      const updatedState = { ...billingInfo, [name]: value };
      setBillingInfo(updatedState);
      // Pass updated state to getTotal to ensure it uses the latest values
      getTotal(billingInfo.country.trim(), null, updatedState);
    } else if (name === "is_saudi") {
      // Reset customer_type and vat_registered when Saudi status changes
      const updatedState = {
        ...billingInfo,
        [name]: value,
        customer_type: value === "yes" ? "individual" : billingInfo.customer_type,
        vat_registered: value === "no" ? "" : billingInfo.vat_registered,
      };
      setBillingInfo(updatedState);
      // Recalculate VAT with updated state - pass updatedState to getTotal
      getTotal(billingInfo.country.trim(), null, updatedState);
    } else if (name === "customer_type") {
      setBillingInfo((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else if (name == "country") {
      getTotal(value.trim());
      setBillingInfo({ ...billingInfo, [name]: value });
    } else if (["firstName", "lastName", "city"].includes(name)) {
      const regex = /^[a-zA-Z\s]*$/;
      if (regex.test(value) || value === "") {
        setBillingInfo((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    } else if (name == "postalCode") {
      const regex = /^[0-9]*$/;
      if (regex.test(value) || value === "") {
        setBillingInfo((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    } else {
      setBillingInfo({ ...billingInfo, [name]: value });
      delete errors[name];
      setErrors(errors);
    }
  };
  const handlePromoChange = async (e) => {
    const { name, value } = e.target;
    const updatedBillingInfo = { ...billingInfo, [name]: value };
    setBillingInfo(updatedBillingInfo);
    
    // Clear existing timeout
    if (promoCodeTimeoutRef.current) {
      clearTimeout(promoCodeTimeoutRef.current);
    }
    
    // Only validate if value is not empty and has at least 3 characters
    if (!value || value.trim().length < 3) {
      // Clear coupon state when promo code is removed
      isRemovingPromoCodeRef.current = true;
      setCoupon(null);
      const newErrors = { ...errors };
      delete newErrors["promoCode"];
      setError(newErrors);
      // Recalculate without discount - pass false to explicitly indicate no discount
      // Use setTimeout to ensure coupon state is cleared first
      setTimeout(() => {
        getTotal(updatedBillingInfo.country?.trim() || "", false, updatedBillingInfo);
        isRemovingPromoCodeRef.current = false;
      }, 0);
      return;
    }
    
    // Debounce: wait 800ms before making API call
    promoCodeTimeoutRef.current = setTimeout(async () => {
      try {
        setCoupon(null);
        const response = await axios.get(
          `${base_url}/api/promocode?promoCode=${value}`,
          ConfigToken()
        );
        if (response.status == 206) {
          setError({ ...errors, promoCode: response.data.data });
          // Invalid promo code - clear coupon and recalculate without discount
          setCoupon(null);
          getTotal(updatedBillingInfo.country?.trim() || "", false, updatedBillingInfo);
        } else if (response.status == 200) {
          setCoupon(response.data);
          // Valid promo code - recalculate with discount (getTotal will recalculate from items first, then apply discount)
          getTotal(updatedBillingInfo.country?.trim() || "", response.data.discount, updatedBillingInfo);
          const newErrors = { ...errors };
          delete newErrors["promoCode"];
          setError(newErrors);
        }
      } catch (error) {
        // Error - clear coupon and recalculate without discount
        setCoupon(null);
        getTotal(updatedBillingInfo.country?.trim() || "", false, updatedBillingInfo);
      }
    }, 800);
  };

  const uploadCompanyFile = async (e, fileType) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    setIsUploading((prev) => ({ ...prev, [fileType]: true }));
    try {
      const file = files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("file_name", file.name);

      const response = await axios.post(
        `${base_url}/api/upload_file/`,
        formData,
        ConfigToken()
      );

      setBillingInfo((prevState) => ({
        ...prevState,
        [fileType]: response.data.file_url,
        [`${fileType}_name`]: file.name,
      }));

      delete errors[fileType];
      setError(errors);
    } catch (error) {
      console.error("Error uploading file:", error);
      showErrorToast(
        lang === "ar" ? "خطأ في رفع الملف" : "Error uploading file",
        "#D83D99"
      );
    } finally {
      setIsUploading((prev) => ({ ...prev, [fileType]: false }));
      e.target.value = "";
    }
  };

  const removeFile = (fileType) => {
    setBillingInfo((prevState) => ({
      ...prevState,
      [fileType]: "",
      [`${fileType}_name`]: "",
    }));
    delete errors[fileType];
    setError(errors);
  };

  // const handleQuantityChange = async (addonId, change) => {
  //     console.log(addonId,change)
  //     const existLocalData = JSON.parse(localStorage.getItem('payloads')) || {};
  //     try {
  //         let newQty;
  //         let updatedDetails;

  //         setCartDetails((prevCartDetails) => {
  //             updatedDetails = { ...prevCartDetails };
  //             console.log('addons')
  //             updatedDetails.item_details.addon_items = updatedDetails.item_details.addon_items.map((addon) => {
  //                 if (addon.id === addonId) {
  //                     newQty = (addon.qty) + (change);

  //                     if (newQty < 0) {
  //                         newQty = addon.qty;
  //                         return addon;
  //                     }

  //                     return {
  //                         ...addon,
  //                         qty: newQty,

  //                     };
  //                 }
  //                 return addon;
  //             });
  //             console.log(updatedDetails,"add ons ")
  //             return updatedDetails;
  //         });

  //         if (newQty === 0) {
  //             removeItem(addonId, "addon");
  //             return;
  //         }

  //         setLoading(true)
  //         const qtyData = { qty: newQty } ;
  //         console.log(qtyData,"")
  //         const response = await axios.put(`${base_url}/api/order-item/${addonId}/`,qtyData, ConfigToken());

  //         const responseData = response.data;

  //         setCartDetails((prevCartDetails) => {
  //             const updatedDetails = { ...prevCartDetails };

  //             updatedDetails.item_details.addon_items = updatedDetails.item_details.addon_items.map((addon) => {
  //                 if (addon.id === responseData.data.id) {
  //                     if (existLocalData) {
  //                         const addonsData = {
  //                             order_name: "Addons",
  //                             item_list: updatedDetails?.item_details?.addon_items?.map(item =>({
  //                                 design_id: item.item__id,
  //                                 addon_name: item.item_name,
  //                                 addon_arabic: item.item__name_arabic,
  //                                   category:item?.category, // placeholder, update if dynamic
  //                                 total_price:parseFloat(responseData.data.subtotal_price),
  //                                 item_type: item.item_type,
  //                                 unit_price: item.unit_price.toFixed(2),
  //                                 unit_time: item.unit_time.toFixed(2),
  //                                 qty: item.qty.toString(),
  //                             }))
  //                         };

  //                         const updatedPayloads = {
  //                             ...existLocalData,
  //                             addons: addonsData
  //                         };
  //                         localStorage?.setItem('payloads', JSON.stringify(updatedPayloads))

  //                     }
  //                     return {
  //                         ...addon,
  //                         qty: responseData.data.qty,
  //                         status: responseData.data.status,
  //                         subtotal_price: parseFloat(responseData.data.subtotal_price),
  //                     };

  //                 }
  //                 return addon;
  //             });

  //             updatedDetails.grand_total = responseData.grand_total;
  //             updatedDetails.total_amount = responseData.total_amount;
  //             updatedDetails.total_time = responseData.total_time;

  //             return updatedDetails;
  //         });

  //         toast.success("Cart updated successfully", {
  //             position: toast?.POSITION?.TOP_RIGHT,
  //             toastId: "required-toast-qty",
  //             autoClose: 3000,
  //             style: {
  //                 color: "#1BA56F",
  //                 fontWeight: "700",
  //             },
  //         });
  //     } catch (error) {
  //         console.error("Error updating addon:", error);
  //     } finally {
  //         setLoading(false)
  //     }
  // };

  const handleQuantityChange = async (addonId, change) => {
    const existLocalData = JSON.parse(localStorage.getItem("payloads")) || {};

    const currentAddon = cartDetails?.item_details?.addon_items?.find(
      (addon) => addon.id === addonId
    );
    if (!currentAddon) return;

    let newQty = currentAddon.qty + change;

    if (newQty < 0) {
      newQty = currentAddon.qty;
    }

    if (newQty === 0) {
      removeItem(addonId, "addon");
      return;
    }

    try {
      setLoading(true);

      const qtyData = { qty: newQty };
      const response = await axios.put(
        `${base_url}/api/order-item/${addonId}/`,
        qtyData,
        ConfigToken()
      );
      const responseData = response.data;

      // Refresh cart data from API to get accurate totals
      const cartResponse = await axios.get(
        `${base_url}/api/order/cart/`,
        ConfigToken()
      );

      if (cartResponse.data) {
        const cartData = cartResponse.data;

        // Update cartDetails with fresh API data (preserve item_details structure)
        // Don't set totals manually - let getTotal calculate everything
        const updatedCartDetails = {
          ...cartData,
        };

        if (cartData.item_details) {
          updatedCartDetails.item_details = {
            bundle_items: (cartData.item_details.bundle_items || []).filter(item => item && Object.keys(item).length > 0),
            addon_items: (cartData.item_details.addon_items || []).filter(item => item && Object.keys(item).length > 0),
          };
        } else {
          updatedCartDetails.item_details = {
            bundle_items: [],
            addon_items: [],
          };
        }

        // Update localStorage if needed
        if (existLocalData && updatedCartDetails.item_details.addon_items.length > 0) {
          const addonsData = {
            order_name: "Addons",
            item_list: updatedCartDetails.item_details.addon_items.map((item) => ({
              design_id: item.item__id,
              addon_name: item.item_name,
              addon_arabic: item.item__name_arabic,
              category: item?.category,
              total_price: parseFloat(item.subtotal_price || 0),
              item_type: item.item_type,
              unit_price: item.unit_price?.toFixed(2) || String(item.unit_price),
              unit_time: item.unit_time?.toFixed(2) || String(item.unit_time),
              qty: item.qty?.toString() || String(item.qty),
            })),
          };
          const updatedPayloads = {
            ...existLocalData,
            addons: addonsData,
          };
          localStorage.setItem("payloads", JSON.stringify(updatedPayloads));
        }

        // Update cart details, then let getTotal calculate all totals correctly
        setCartDetails(updatedCartDetails);

        // getTotal will recalculate everything from the updated cartDetails and apply discount/tax correctly
        // Use setTimeout to ensure React has processed the state update
        setTimeout(() => {
          getTotal(billingInfo.country?.trim() || "", coupon?.discount || null, billingInfo);
          setLoading(false);
        }, 150);
      } else {
        setLoading(false);
      }

      // toast.success("Cart updated successfully", {
      //   position: toast?.POSITION?.TOP_RIGHT,
      //   toastId: "required-toast-qty",
      //   autoClose: 3000,
      //   style: {
      //     color: "#1BA56F",
      //     fontWeight: "700",
      //     borderRadius:"0px"
      //   },
      // });
      // toastMessage();
      showSuccessToast(
        lang === "ar" ? "تم تحديث السلة بنجاح." : "Cart updated successfully",
        "#D83D99"
      );
    } catch (error) {
      console.error(
        lang === "ar" ? "خطأ في تحديث الإضافات" : "Error updating addon:",
        error
      );
      setLoading(false);
      // On error, refresh cart data to restore correct state
      getCartData();
    }
  };

  const handleBackClick = () => {
      navigateToDetailHistory();
    // setShowModal(true);
  };

  const confirmNavigation = () => {
    setShowModal(false);
    localStorage?.removeItem("payloads");
    navigateToDetailHistory();
  };

  const navigateToDetailHistory = () => {
    if (cartDetails.bundle_id) {
      navigate(`/bundldetail/${routeNames[cartDetails.bundle_id]}`, {
        state: { project_name: cartDetails.project_name },
      });
    } else {
      navigate(`/custombundl`, {
        state: { project_name: cartDetails.project_name, isBackToCustom: true },
      });
    }
  };

  const cancelNavigation = () => {
    setShowModal(false);
  };

  return (
    <>
      {loading ? (
        <Bgloader />
      ) : (
        <div>
          {/* <ToastContainer /> */}
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                color: "#1BA56F",
                fontWeight: "700",
              },
            }}
          />
          <Navbar isLang={lang} setIsLang={setLang} />
          {showModal && (
            <div className="fixed inset-0 z-50  bg-gray-800 bg-opacity-50 flex items-center justify-center">
              <div className="bg-white rounded-none shadow-lg p-6 max-w-sm border-black border-[1px]">
                <p className="text-lg font-[400] text-gray-900 text-center">
                  {lang === "ar"
                    ? "سيتم إفراغ الإضافات الخاصة بك."
                    : "Your Add-ons will be emptied."}
                </p>
                <div className="mt-4 flex justify-center gap-3">
                  <button
                    onClick={() => confirmNavigation()}
                    className="px-4 py-2 bg-[#0BA6C4] text-white rounded-none uppercase"
                  >
                    {lang === "ar" ? "نعم" : "Yes"}
                  </button>
                  <button
                    onClick={cancelNavigation}
                    className="px-4 py-2 text-black border-[1px] border-black rounded-none uppercase"
                  >
                    {lang === "ar" ? "لا" : "No"}
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="mycart" style={{ position: "relative" }}>
            <div className="cart !xs:border-none  sm:!pb-[170px] !pb-[170px] xs:!pb-[20px]">
                <div className={'sticky top-0'}>
              <p
                className={`flex items-center text-black mt-[2%] text-[18px] font-[500] ${
                  lang === "ar"
                    ? "lg:mr-[-70px] sm:mr-[-38px]"
                    : "lg:ml-[-69px] sm:ml-[-38px]"
                }`}
              >
                <img
                  src={backIcon}
                  alt="Back"
                  className={`w-[24px] sm:w-[30px] cursor-pointer ${
                    lang === "ar"
                      ? "ml-2 scale-x-[-1] sm:mr-[30px]"
                      : "mr-2 sm:ml-[30px]"
                  }`}
                  onClick={handleBackClick}
                />
                <span className="cursor-pointer" onClick={handleBackClick}>
                  {lang === "ar" ? "العودة إلى الباقة" : "Back to Bundl"}
                </span>
              </p>
              {/* {isDirect == false && <p onClick={()=>handleBackClick()} className='flex font-[500] cursor-pointer !text-[18px] items-center text-black mt-[2%]'> <img src={backIcon} className='mr-2 w-[30px]' onClick={()=>handleBackClick()}></img> Back to Bundl </p>}           */}
              <p className="!xs:text-[16px] font-[700] !sm:text-[20px]">
                {lang === "ar" ? "عربة التسوق الخاصة بك" : "Your Cart"}
              </p>
              {isMobile ? (
                <>
                  {cartDetails?.item_details?.bundle_items?.length > 0 && (
                    <div className="flex justify-between border-b pb-2 !border-black">
                      <div className="font-[700] text-[20px]">
                        {lang === "ar"
                          ? processArabicText(cartDetails?.bundl_arabic)
                          : cartDetails?.bundl_english}
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="font-[700] text-[20px]">
                          {amountDecimal(
                            Math.round(
                              cartDetails?.bundle_price +
                                ((location?.state?.selectedLanguage || cartDetails?.language) ===
                                  "Both" ? 2000 : 0) +
                                ((location?.state?.selectedIllustrations || cartDetails?.illustrations) ===
                                  "illustrations" ? 2000 : 0)
                            )
                          )}{" "}
                          {lang === "ar" ? "ريال" : "SAR"}
                        </div>
                        <img
                          style={{ cursor: "pointer" }}
                          src={DeleteIcon}
                          alt="Delete Icon"
                          onClick={() => emptyCart()}
                        />
                      </div>
                    </div>
                  )}

                  {/* {cartDetails?.item_details?.bundle_items?.map((row,index) => (
                            <div className='flex justify-between border-b pb-2 !border-black'> 
                            <div>
                            <div className='font-[700] text-[20px]'>{row.item_name}</div>
                            <div className='font-[500] ml-8'> {row.unit_price} SAR</div>
                            </div>
                            <p className='flex items-center !mb-0 justify-center'><img style={{ cursor: 'pointer' }} src={DeleteIcon} alt="Delete Icon" onClick={() => removeItem(row.id, 'bundle')}/></p>
                             </div>
                        ))} */}
                  <div className="mt-3">
                    {cartDetails?.item_details?.bundle_items?.map(
                      (row, index) => (
                        <div
                          key={row.id || `bundle-${index}`}
                          className={`flex ${
                            index ===
                              cartDetails?.item_details?.bundle_items?.length -
                                1 && "border-b border-black"
                          } w-full`}
                        >
                          <div className="font-[700] "> {row.qty} </div>
                          {/* <div className="font-[700] text-[20px] ml-2">
                            {lang === "ar"
                              ? processArabicText(row.item__name_arabic)
                              : row.item_name}
                              
                          </div> */}
                        <div className="font-[700] text-[18px] ml-2">
  {lang === "ar"
    ? processArabicText(row.item__name_arabic)
    : row.item_name}

  {row?.item_name.includes("Brand Identity") && (
    <>
      {" "}
      {(location?.state?.selectedLanguage || cartDetails?.language) === "Both"
        ? lang === "ar" ? processArabicText("(الإنجليزية والعربية)") :"(English & Arabic)"
        : (location?.state?.selectedLanguage || cartDetails?.language) === "Arabic"
        ? lang === "ar" ? processArabicText("(عربي)") : "(Arabic)"
        : ""}
      {(location?.state?.selectedIllustrations || cartDetails?.illustrations) === "illustrations" && (lang === "ar" ? processArabicText("(الرسوم التوضيحية) ") : " (Illustrations)")}
    </>
  )}
</div>

                        </div>
                      )
                    )}
                  </div>

                  {cartDetails?.item_details?.addon_items?.length > 0 && (
                    <div
                      className={`font-[700] text-[20px] mt-2 ${
                        lang === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {lang === "ar" ? "إضافات" : "Add ons"}
                    </div>
                  )}
                  {cartDetails?.item_details?.addon_items?.map((row, index) => (
                    <div
                      key={row.id || `addon-${index}`}
                      className={`flex ${
                        index ===
                          cartDetails?.item_details?.addon_items?.length - 1 &&
                        "border-b border-black"
                      } w-full mt-2 justify-evenly`}
                    >
                      <div className="w-full">
                        <div className="font-[700] text-[18px] ">
                          {lang === "ar"
                            ? processArabicText(row.item__name_arabic)
                            : row.item_name}
                        </div>
                        {/* <div className='font-[500] '> {row.subtotal_price} SAR</div> */}
                      </div>
                      <p style={{direction: "ltr"}}
                        className={`w-full max-h-[36px] !mb-2 flex ${
                          lang === "ar" ? "flex-row-reverse" : "flex-row"
                        } justify-end items-center gap-2`}
                      >
                        <div className={`flex flex-row`}>
                        <button
                          style={{
                            borderColor: "black",
                            borderStyle: "solid",
                            borderWidth: "1px",
                            width: "36px",
                            minWidth: "36px",
                            height: "36px",
                          }}
                          onClick={() => handleQuantityChange(row?.id, -1)}
                          className={`flex items-center justify-center flex-shrink-0`}
                        >
                          <RemoveIcon />
                        </button>
                        <span
                          style={{
                            borderColor: "black",
                            borderStyle: "solid",
                            borderWidth: "1px",
                            width: "50px",
                            minWidth: "50px",
                            maxWidth: "50px",
                            height: "36px",
                          }}
                          className={`${
                            lang === "ar" ? " !border-l-0" : "!border-r-0"
                          } px-2 !text-[20px] flex items-center justify-center flex-shrink-0`}
                        >
                          {row?.qty || 0}
                        </span>
                        <button
                          style={{
                            borderColor: "black",
                            borderStyle: "solid",
                            borderWidth: "1px",
                            width: "36px",
                            minWidth: "36px",
                            height: "36px",
                          }}
                          onClick={() => handleQuantityChange(row?.id, 1)}
                          className={`flex items-center justify-center flex-shrink-0`}
                        >
                          <AddIcon />
                        </button>
                        </div>
                        <img
                          style={{ cursor: "pointer" }}
                          src={DeleteIcon}
                          alt="Delete Icon"
                          onClick={() => removeItem(row?.id, "addon")}
                        />
                      </p>
                    </div>
                  ))}
                </>
              ) : (
                <table className="w-full border-none" aria-label="simple table">
                  <thead>
                    <tr
                      className={`${
                        lang === "ar" ? "!text-right" : "!text-left"
                      } text-[20px]`}
                    >
                      <td
                        className={`${
                          lang === "ar" ? "text-right" : "text-left"
                        } w-[20%] text-[#00000080] pb-3`}
                      >
                        {lang === "ar" ? "الباقة" : "Item"}
                      </td>
                      {/* <td className='text-[#00000080] w-[30%] pb-3'  align="center">Quantity</td> */}
                      <td
                        className="text-[#00000080] w-[30%]    pb-3"
                        align="center"
                      >
                        {lang === "ar" ? "السعر​" : "Price"}
                      </td>
                      <td
                        className="text-[#00000080] w-[20%]    pb-3"
                        align="center"
                      >
                        {lang === "ar" ? "الإجراء" : "Action"}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {/* <p className='text-[#000] font-[700] text-[20px]'>{cartDetails?.bundl_english}</p> */}
                    <>
                      {cartDetails?.item_details?.bundle_items?.length > 0 && (
                        <tr
                          className={`text-[#000] font-[700] text-[20px] border-b border-black mb-2 `}
                        >
                          <td className=" !py-2" scope="row">
                            {lang === "ar"
                              ? processArabicText(cartDetails?.bundl_arabic)
                              : cartDetails?.bundl_english}
                          </td>
                          <td className=" !py-2" align="center">
                            {amountDecimal(
                              Math.round(
                                cartDetails?.bundle_price +
                                  ((location?.state?.selectedLanguage || cartDetails?.language) ===
                                    "Both" ? 2000 : 0) +
                                  ((location?.state?.selectedIllustrations || cartDetails?.illustrations) ===
                                    "illustrations" ? 2000 : 0)
                              )
                            )}{" "}
                            {lang === "ar" ? "ريال" : "SAR"}
                          </td>
                          <td className=" !py-2" align="center">
                            <img
                              style={{ cursor: "pointer" }}
                              src={DeleteIcon}
                              alt="Delete Icon"
                              onClick={() => emptyCart()}
                            />
                          </td>
                        </tr>
                      )}
                    </>
                    {cartDetails?.item_details?.bundle_items?.map(
                      (row, index) => (
                        <tr
                          key={row.id || `bundle-row-${index}`}
                          className={` ${
                            index ===
                              cartDetails?.item_details?.bundle_items?.length -
                                1 && "border-b border-black"
                          } w-full`}
                        >
                          <td className="text-[#000] font-[700] !text-[18px] !px-[2%] !py-1">
                            {row.qty}{" "}
                            {lang === "ar"
                              ? processArabicText(row.item__name_arabic)
                              : row?.item_name}
                              {row?.item_name.includes('Brand Identity') ? <>
                              {(location?.state?.selectedLanguage || cartDetails?.language) === "Both"
                                  ? lang === "ar" ? processArabicText("(الإنجليزية والعربية)") :"(English & Arabic)"
                                  : (location?.state?.selectedLanguage || cartDetails?.language) === "Arabic"
                                      ? lang === "ar" ? processArabicText("(عربي)") : "(Arabic)"
                                      : ""}
                              {(location?.state?.selectedIllustrations || cartDetails?.illustrations) === "illustrations" && (lang === "ar" ? processArabicText("(الرسوم التوضيحية) ") : " (Illustrations)")}
                          </> : ''}
                          </td>
                        </tr>
                      )
                    )}

                    <tr
                      className={`text-[#000] font-[700] text-[20px] mb-2 mt-4`}
                    >
                      <td
                        className={`${
                          lang === "ar" ? "text-right" : "text-left"
                        } !py-2`}
                        scope="row"
                      >
                        {cartDetails?.item_details?.addon_items?.length > 0 &&
                          (lang === "ar" ? "إضافات" : "Add ons")}
                      </td>
                    </tr>
                    {cartDetails?.item_details?.addon_items?.map(
                      (row, index) => (
                        <tr
                          key={
                            lang === "ar"
                              ? processArabicText(row.item__name_arabic)
                              : row.item_name
                          }
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className={`text-[#000] font-[700] text-[18px] h-inherit ${
                            index ==
                            cartDetails?.item_details?.addon_items.length - 1
                              ? ""
                              : "border-b border-black"
                          } `}
                        >
                          <td className=" !py-2 w-[35%] !px-[2%]" scope="row">
                            {lang === "ar"
                              ? processArabicText(row.item__name_arabic)
                              : `${row.item_name} ${
                                  row.item_name === "Logo & Identity" &&
                                  row.language === "both"
                                    ? "(English & Arabic)"
                                    : row.language
                                    ? row.language
                                    : ""
                                }`}
                          </td>
                          {/* <td className=' !py-2' align="center">{row.qty}</td> */}
                          <td className=" !py-2 " align="center">
                            {amountDecimal(row.subtotal_price)}{" "}
                            {lang === "ar" ? "ريال" : "SAR"}
                          </td>
                          {/* <TableCell align="center"><img style={{width:'23px'}} src={row.DeleteIcon}></img></TableCell> */}
                          <td align="center">
                            <div className={`flex items-center justify-center gap-2 ${
                              lang === "ar" ? "flex-row-reverse" : "flex-row"
                            }`}>
                              <p
                                className={`w-full max-h-[36px] !mb-2 flex ${
                                  lang === "ar"
                                    ? "flex-row-reverse"
                                    : "flex-row justify-end"
                                }   mt-2`}
                              >
                              <button
                                style={{
                                  borderColor: "black",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                  width: "36px",
                                  minWidth: "36px",
                                  height: "36px",
                                }}
                                onClick={() =>
                                  handleQuantityChange(row?.id, -1)
                                }
                                className={` ${
                                  lang === "ar" ? " !border-r-0" : "!border-r-0"
                                } flex items-center justify-center flex-shrink-0`}
                              >
                                <RemoveIcon />
                              </button>
                              <span
                                style={{
                                  borderColor: "black",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                  width: "50px",
                                  minWidth: "50px",
                                  maxWidth: "50px",
                                  height: "36px",
                                }}
                                className={`${
                                  lang === "ar" ? " !border-r-0" : "!border-r-0"
                                } px-2 !text-[20px] flex items-center justify-center flex-shrink-0`}
                              >
                                {row?.qty || 0}
                              </span>
                              <button
                                style={{
                                  borderColor: "black",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                  width: "36px",
                                  minWidth: "36px",
                                  height: "36px",
                                }}
                                onClick={() => handleQuantityChange(row?.id, 1)}
                                className={`flex items-center justify-center flex-shrink-0`}
                              >
                                <AddIcon />
                              </button>
                            </p>
                            <img
                                style={{ cursor: "pointer" }}
                                src={DeleteIcon}
                                alt="Delete Icon"
                                onClick={() => removeItem(row?.id, "addon")}
                              />
                            </div>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              )}
            </div>
            </div>

            <div className="billing sticky top-0 self-start">
              <p>{lang === "ar" ? "عنوان الفواتير" : "Billing Address"}</p>
              <form onSubmit={handlePayment} noValidate>
                <div className="user-name mb-[15px]">
                  <div className={`${lang === "ar" ? "ml-[4%]" : "mr-[4%]"}`}>
                    <label
                      className={`${
                        "firstName" in error ? "text-[#D83D99]" : "opacity-50"
                      }`}
                    >
                      {lang === "ar" ? "الاسم الأول" : "First Name"}{" "}
                      <span className="text-[#D83D99]">*</span>
                    </label>
                    <input
                      name="firstName"
                      value={billingInfo.firstName}
                      onChange={handleBillingChange}
                      className={`rounded-none ${
                        "firstName" in error ? "!border-[#D83D99]" : ""
                      }`}
                    />
                  </div>
                  <div
                    className={`${lang === "ar" ? "mr-[4%]" : "ml-[4%]"}`}
                    style={
                      lang === "ar"
                        ? { margin: "0% 2% 0 0%" }
                        : { margin: "0% 0 0 2%" }
                    }
                  >
                    <label
                      className={`${
                        "lastName" in error ? "text-[#D83D99]" : "opacity-50"
                      }`}
                    >
                      {lang === "ar" ? "اسم العائلة" : "Last Name"}{" "}
                      <span className="text-[#D83D99]">*</span>
                    </label>
                    <input
                      name="lastName"
                      value={billingInfo.lastName}
                      onChange={handleBillingChange}
                      className={`rounded-none ${
                        "lastName" in error ? "!border-[#D83D99]" : ""
                      }`}
                    />
                  </div>
                </div>
                <div className="email mb-[15px]">
                  <label
                    className={`${
                      "email" in error ? "text-[#D83D99]" : "opacity-50"
                    }`}
                  >
                    {lang === "ar" ? "البريد الإلكتروني" : "Email"}{" "}
                    <span className="text-[#D83D99]">*</span>
                  </label>
                  <input
                    name="email"
                    value={billingInfo.email}
                    onChange={handleBillingChange}
                    className={`rounded-none ${
                      "email" in error ? "!border-[#D83D99]" : ""
                    }`}
                  />
                </div>
                <div className="phonenumber mb-[15px]">
                  <label
                    className={`${
                      "phone" in error ? "text-[#D83D99]" : "opacity-50"
                    }`}
                  >
                    {lang === "ar" ? "رقم الهاتف" : "Phone Number"}{" "}
                    <span className="text-[#D83D99]">*</span>
                  </label>
                  <PhoneInput
                    country={"sa"}
                    enableSearch={true}
                    value={billingInfo.phone}
                    onChange={(phone) =>
                      setBillingInfo((prev) => ({ ...prev, phone: `+${phone}` }))
                    }
                    containerClass="!w-full"
                    inputClass={`!w-full !h-[45px] !rounded-none !outline-none ${
                      "phone" in error ? "!border-[#D83D99]" : "!border-[#000000]"
                    }`}
                    buttonClass="!border-[#000000] !rounded-none"
                  />
                </div>
                <div className="country mb-[15px]">
                  <div className={`${lang === "ar" ? "ml-[4%]" : "mr-[4%]"}`}>
                    <label
                      className={`${
                        "country" in error ? "text-[#D83D99]" : "opacity-50"
                      }`}
                    >
                      {lang === "ar" ? "بلد" : "Country"}{" "}
                      <span className="text-[#D83D99]">*</span>
                    </label>
                    <select
                      name="country"
                      // id='vacancySelect'
                      value={billingInfo.country || null}
                      onChange={handleBillingChange}
                      className={`!rounded-none ${
                        "country" in error ? "!border-[#D83D99]" : ""
                      } border !border-black px-2 py-[5px] w-full`}
                    >
                      <option value={null} disabled selected>
                        {" "}
                      </option>
                      {countries.map((country) => (
                        <option>{country}</option>
                      ))}
                    </select>
                  </div>
                  <div
                    className={`${lang === "ar" ? "ml-[4%]" : "mr-[4%]"}`}
                    style={
                      lang === "ar"
                        ? { margin: "0% 2% 0 0%" }
                        : { margin: "0% 0 0 2%" }
                    }
                  >
                    <label
                      className={`${
                        "city" in error ? "text-[#D83D99]" : "opacity-50"
                      }`}
                    >
                      {lang === "ar" ? "مدينة" : "City"}
                      <span className="text-[#D83D99]">*</span>
                    </label>
                    <input
                      name="city"
                      value={billingInfo.city}
                      onChange={handleBillingChange}
                      className={`rounded-none ${
                        "city" in error ? "!border-[#D83D99]" : ""
                      }`}
                    />
                  </div>
                </div>
                <div className="postal-code mb-[15px]">
                  <label
                    className={`${
                      "postalCode" in error ? "text-[#D83D99]" : "opacity-50"
                    }`}
                  >
                    {lang === "ar" ? "الرمز البريدي" : "Postal Code"}
                    {/*<span className="text-[#D83D99]">*</span>*/}
                  </label>
                  <input
                    name="postalCode"
                    value={billingInfo.postalCode}
                    onChange={handleBillingChange}
                    className={`rounded-none ${
                      "postalCode" in error ? "!border-[#D83D99]" : ""
                    }`}
                  />
                </div>

                <div className="is-saudi mb-[15px]">
                  <label
                    className={`${
                      "is_saudi" in error ? "text-[#D83D99]" : "opacity-50"
                    }`}
                  >
                    {lang === "ar" ? "هل أنت مقيم في المملكة العربية السعودية؟" : "Are you based in KSA?"}
                    <span className="text-[#D83D99]">*</span>
                  </label>
                  <div className={`flex gap-4 mt-2 ${lang === "ar" ? "flex-row-reverse" : ""}`}>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="is_saudi"
                        value="yes"
                        checked={billingInfo.is_saudi === "yes"}
                        onChange={handleBillingChange}
                        className="cursor-pointer"
                      />
                      <span>{lang === "ar" ? "نعم" : "Yes"}</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="is_saudi"
                        value="no"
                        checked={billingInfo.is_saudi === "no"}
                        onChange={handleBillingChange}
                        className="cursor-pointer"
                      />
                      <span>{lang === "ar" ? "لا" : "No"}</span>
                    </label>
                  </div>
                </div>

                {billingInfo?.is_saudi === "yes" && (
                  <>
                    <div className="customer-type mb-[15px]">
                      <label
                        className={`${
                          "customer_type" in error
                            ? "text-[#D83D99]"
                            : "opacity-50"
                        }`}
                      >
                        {lang === "ar" ? "نوع العميل" : "Customer Type"}
                        <span className="text-[#D83D99]">*</span>
                      </label>
                      <select
                        className={`w-[100%] py-[5px] px-2 !rounded-none border-[1px] outline-none  ${
                          "customer_type" in error
                            ? "!border-[#D83D99]"
                            : "border-black border-solid"
                        } `}
                        name="customer_type"
                        value={billingInfo.customer_type}
                        onChange={handleBillingChange}
                      >
                        <option value="individual">
                          {lang === "ar" ? "فرد" : "Individual"}
                        </option>
                        <option value="company">
                          {lang === "ar" ? "شركة" : "Company"}
                        </option>
                      </select>
                    </div>

                    <div className="trn-code mb-[15px]">
                      <label
                        className={`${
                          "vat_registered" in error
                            ? "text-[#D83D99]"
                            : "opacity-50"
                        }`}
                      >
                        {lang === "ar" ? "التسجیل الضریبي" : "Tax Treatment"}
                        <span className="text-[#D83D99]">*</span>
                      </label>
                      <select
                        className={`w-[100%] py-[5px] px-2 !rounded-none border-[1px] outline-none  ${
                          "vat_registered" in error
                            ? "!border-[#D83D99]"
                            : "border-black border-solid"
                        } `}
                        name="vat_registered"
                        value={billingInfo.vat_registered}
                        onChange={handleBillingChange}
                      >
                        <option value="" disabled selected></option>
                        <option value={"vat"}>
                          {lang === "ar"
                            ? "مسجل بقیمة الضریبة المضافة"
                            : "VAT Registered"}
                        </option>
                        <option value={"non_vat"}>
                          {lang === "ar"
                            ? "غیر مسجل بقیمة الضریبة المضافة"
                            : "Non-VAT Registered"}
                        </option>
                      </select>
                    </div>

                    {tax && (
                      <div className="trn-code mb-[15px]">
                        <label
                          className={`${
                            "trn" in error ? "text-[#D83D99]" : "opacity-50"
                          }`}
                        >
                          {lang === "ar" ? "الرقم الضریبي" : "TRN Number"}
                          <span className="text-[#D83D99]">*</span>
                        </label>
                        <input
                          name="trn"
                          value={billingInfo.trn}
                          onChange={handleBillingChange}
                          className={`rounded-none w-[100%] ${
                            "trn" in error ? "!border-[#D83D99]" : ""
                          }`}
                        />
                      </div>
                    )}

                    {billingInfo?.customer_type === "company" && (
                      <>
                        <div className="vat-certificate mb-[15px]">
                          <label
                            className={`${
                              "vat_certificate" in error
                                ? "text-[#D83D99]"
                                : "opacity-50"
                            }`}
                          >
                            {lang === "ar"
                              ? "شهادة ضريبة القيمة المضافة / الرقم الضريبي"
                              : "VAT Certificate / VAT Number"}
                            {billingInfo.vat_registered === "vat" && (
                              <span className="text-[#D83D99]">*</span>
                            )}
                          </label>
                          <p
                            className={`border-1 h-[45px] text-[14px] uppercase
                              ${
                                window?.innerWidth <= 500
                                  ? "w-[61%]"
                                  : "w-[300px]"
                              }
                            !border-[#000000] flex items-center justify-center text-[#000000] cursor-pointer lg:ml-2 lg:mt-4 md:ml-2 md:mt-4 xs:ml-0 xs:mt-0 p-[5px] ${
                              isUploading.vat_certificate
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                            onClick={() => {
                              if (!isUploading.vat_certificate) {
                                document.getElementById("vat_certificate").click();
                              }
                            }}
                          >
                            <input
                              type="file"
                              hidden
                              name="vat_certificate"
                              id="vat_certificate"
                              onChange={(e) =>
                                uploadCompanyFile(e, "vat_certificate")
                              }
                              className=""
                              disabled={isUploading.vat_certificate}
                              accept=".pdf,.jpg,.jpeg,.png"
                            />
                            {isUploading.vat_certificate ? (
                              <div className="flex items-center">
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-black mr-2"></div>
                                {lang === "ar" ? "جاري الرفع..." : "Uploading..."}
                              </div>
                            ) : (
                              <>
                                <img
                                  className="h-[25px] w-[40px]"
                                  src={Blackupload}
                                  alt="Upload Icon"
                                />
                                {lang === "ar"
                                  ? "إضافة المحتوى"
                                  : "Upload Content"}
                              </>
                            )}
                          </p>
                          {billingInfo.vat_certificate && billingInfo.vat_certificate_name && (
                            <div className="flex flex-wrap mt-2">
                              <div
                                className={`bg-black text-[14px] text-white py-1 px-2 mb-2 flex items-center ${
                                  lang === "ar" ? "mr-2" : "mr-2"
                                }`}
                              >
                                {billingInfo.vat_certificate_name}
                                <CloseIcon
                                  onClick={() => removeFile("vat_certificate")}
                                  className={`cursor-pointer ${
                                    lang === "ar" ? "mr-2" : "ml-2"
                                  }`}
                                  style={{ fontSize: "18px" }}
                                />
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="national-address mb-[15px]">
                          <label
                            className={`${
                              "national_address_certificate" in error
                                ? "text-[#D83D99]"
                                : "opacity-50"
                            }`}
                          >
                            {lang === "ar"
                              ? "شهادة العنوان الوطني"
                              : "National Address Certificate"}
                            {billingInfo.vat_registered === "vat" && (
                              <span className="text-[#D83D99]">*</span>
                            )}
                          </label>
                          <p
                            className={`border-1 h-[45px] text-[14px] uppercase
                              ${
                                window?.innerWidth <= 500
                                  ? "w-[61%]"
                                  : "w-[300px]"
                              }
                            !border-[#000000] flex items-center justify-center text-[#000000] cursor-pointer lg:ml-2 lg:mt-4 md:ml-2 md:mt-4 xs:ml-0 xs:mt-0 p-[5px] ${
                              isUploading.national_address_certificate
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                            onClick={() => {
                              if (!isUploading.national_address_certificate) {
                                document
                                  .getElementById("national_address_certificate")
                                  .click();
                              }
                            }}
                          >
                            <input
                              type="file"
                              hidden
                              name="national_address_certificate"
                              id="national_address_certificate"
                              onChange={(e) =>
                                uploadCompanyFile(e, "national_address_certificate")
                              }
                              className=""
                              disabled={isUploading.national_address_certificate}
                              accept=".pdf,.jpg,.jpeg,.png"
                            />
                            {isUploading.national_address_certificate ? (
                              <div className="flex items-center">
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-black mr-2"></div>
                                {lang === "ar" ? "جاري الرفع..." : "Uploading..."}
                              </div>
                            ) : (
                              <>
                                <img
                                  className="h-[25px] w-[40px]"
                                  src={Blackupload}
                                  alt="Upload Icon"
                                />
                                {lang === "ar"
                                  ? "إضافة المحتوى"
                                  : "Upload Content"}
                              </>
                            )}
                          </p>
                          {billingInfo.national_address_certificate &&
                            billingInfo.national_address_certificate_name && (
                              <div className="flex flex-wrap mt-2">
                                <div
                                  className={`bg-black text-[14px] text-white py-1 px-2 mb-2 flex items-center ${
                                    lang === "ar" ? "mr-2" : "mr-2"
                                  }`}
                                >
                                  {billingInfo.national_address_certificate_name}
                                  <CloseIcon
                                    onClick={() =>
                                      removeFile("national_address_certificate")
                                    }
                                    className={`cursor-pointer ${
                                      lang === "ar" ? "mr-2" : "ml-2"
                                    }`}
                                    style={{ fontSize: "18px" }}
                                  />
                                </div>
                              </div>
                            )}
                        </div>

                        <div className="trade-license mb-[15px]">
                          <label
                            className={`${
                              "trade_license" in error
                                ? "text-[#D83D99]"
                                : "opacity-50"
                            }`}
                          >
                            {lang === "ar"
                              ? "رخصة تجارية"
                              : "Trade License"}
                            {billingInfo.vat_registered === "vat" && (
                              <span className="text-[#D83D99]">*</span>
                            )}
                          </label>
                          <p
                            className={`border-1 h-[45px] text-[14px] uppercase
                              ${
                                window?.innerWidth <= 500
                                  ? "w-[61%]"
                                  : "w-[300px]"
                              }
                            !border-[#000000] flex items-center justify-center text-[#000000] cursor-pointer lg:ml-2 lg:mt-4 md:ml-2 md:mt-4 xs:ml-0 xs:mt-0 p-[5px] ${
                              isUploading.trade_license
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                            onClick={() => {
                              if (!isUploading.trade_license) {
                                document.getElementById("trade_license").click();
                              }
                            }}
                          >
                            <input
                              type="file"
                              hidden
                              name="trade_license"
                              id="trade_license"
                              onChange={(e) =>
                                uploadCompanyFile(e, "trade_license")
                              }
                              className=""
                              disabled={isUploading.trade_license}
                              accept=".pdf,.jpg,.jpeg,.png"
                            />
                            {isUploading.trade_license ? (
                              <div className="flex items-center">
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-black mr-2"></div>
                                {lang === "ar" ? "جاري الرفع..." : "Uploading..."}
                              </div>
                            ) : (
                              <>
                                <img
                                  className="h-[25px] w-[40px]"
                                  src={Blackupload}
                                  alt="Upload Icon"
                                />
                                {lang === "ar"
                                  ? "إضافة المحتوى"
                                  : "Upload Content"}
                              </>
                            )}
                          </p>
                          {billingInfo.trade_license && billingInfo.trade_license_name && (
                            <div className="flex flex-wrap mt-2">
                              <div
                                className={`bg-black text-[14px] text-white py-1 px-2 mb-2 flex items-center ${
                                  lang === "ar" ? "mr-2" : "mr-2"
                                }`}
                              >
                                {billingInfo.trade_license_name}
                                <CloseIcon
                                  onClick={() => removeFile("trade_license")}
                                  className={`cursor-pointer ${
                                    lang === "ar" ? "mr-2" : "ml-2"
                                  }`}
                                  style={{ fontSize: "18px" }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </>
                )}
                <div className="promo-code mb-[15px]">
                  <label
                    className={`${
                      "promoCode" in error ? "text-[#D83D99]" : "opacity-50"
                    }`}
                  >
                    {lang === "ar" ? "الرمز الترويجي" : "Promo Code"}
                  </label>
                  <input
                    name="promoCode"
                    value={billingInfo.promoCode}
                    onChange={handlePromoChange}
                    className={`rounded-none ${
                      "promoCode" in error ? "!border-[#D83D99]" : ""
                    }`}
                  />
                </div>

                <div className="cart-total-container border-[1px] border-black p-[2%_0_0_0]">
                  <div
                    className="total justify-between sm:pl-[3%] xs:pl-[3%] mr-4"
                    style={{ display: "flex" }}
                  >
                    <p
                      className="!text-[20px] xs:mb-0 sm:mb-auto !font-[400]"
                    >
                      {cartDetails.actual_total_amount > cartDetails.total_amount
                        ? (lang === "ar" ? "السعر (المبلغ الكامل) :" : "Price:")
                        : (lang === "ar" ? "السعر :" : "Price:")}
                    </p>
                    <p
                      className="!text-[20px] xs:mb-0 sm:mb-auto text-right !font-[400]"
                    >
                      {formatAmountWithDecimals(cartDetails.actual_total_amount || cartDetails.total_amount || 0)}
                      {lang === "ar" ? "\u00A0\u00A0ريال" : "\u00A0\u00A0SAR"}
                    </p>
                  </div>
                  {cartDetails.actual_total_amount > cartDetails.total_amount && (
                    <div
                      className="total justify-between sm:pl-[3%] xs:pl-[3%] mr-4"
                      style={{ display: "flex" }}
                    >
                      <p
                        className="!text-[20px] !font-[400]"
                      >
                        {lang === "ar" ? "الخصم :" : "Discount:"}
                      </p>
                      <p
                        className="!text-[20px] text-right !font-[400]"
                      >
                        -{formatAmountWithDecimals(cartDetails.actual_total_amount - cartDetails.total_amount)}
                        {lang === "ar" ? "\u00A0\u00A0ريال" : "\u00A0\u00A0SAR"}
                      </p>
                    </div>
                  )}
                  <div
                    className="total justify-between sm:pl-[3%] xs:pl-[3%] mr-4"
                    style={{ display: "flex" }}
                  >
                    <p
                      className="!text-[20px] !font-[400]"
                      // style={{ width: "53%" }}
                    >
                      {lang === "ar" ? "ضريبه القيمه المضافه :" : "TAX:"}
                    </p>
                    <p
                      className="!text-[20px] text-right !font-[400]"
                      // style={{ width: "40%" }}
                    >
                      {formatAmountWithDecimals(cartDetails.tax || 0)}
                      {/* {lang === "ar" ? "ريال" : "SAR"} */}
                      {lang === "ar" ? "\u00A0\u00A0ريال" : "\u00A0\u00A0SAR"}
                    </p>
                  </div>
                  <div className="border-t-[1px] border-black p-[2%_0_0_2%]">
                    <div
                      className="justify-between font-[700] mr-4"
                      style={{ display: "flex" }}
                    >
                      <p
                        className="!text-[20px] xs:mb-0 sm:mb-auto ml-[6px]"
                        // style={{ width: "50%" }}
                      >
                        <img
                          src={BlackDollor}
                          className={`inline-block  ${
                            lang === "ar" ? "ml-[18px]" : "mr-[18px]"
                          }`}
                        ></img>
                        {lang === "ar" ? "السعر الإجمالي :" : "Total Price :"}
                      </p>
                      <p
                        className="!text-[20px] xs:mb-0 sm:mb-auto text-right"
                        // style={{ width: "40%" }}
                      >
                        {formatAmountWithDecimals(cartDetails.grand_total || 0)}
                        {/* {lang === "ar" ? "ريال" : `${"  "}SAR`}{" "} */}
                        {lang === "ar" ? "\u00A0\u00A0ريال" : "\u00A0\u00A0SAR"}
                      </p>
                    </div>
                    <div
                      className="justify-between  font-[700] mr-4"
                      style={{ display: "flex" }}
                    >
                      <p className="!text-[20px] mb-0">
                        <img
                          src={BlackTime}
                          className={`inline-block ${
                            lang === "ar" ? "ml-3 mr-[-5px]" : "mr-3"
                          }`}
                        ></img>
                        {lang === "ar"
                          ? "المدة الإجمالية :"
                          : "Total Duration :"}
                      </p>
                      <p
                        className="!text-[20px]  text-right "
                        // style={{ width: "43%" }}
                      >
                        {isNaN(Math.round(cartDetails.total_time))
                          ? 0
                          : Math.round(cartDetails.total_time)}
                        {lang === "ar" ? "\u00A0\u00A0\u00A0يوم" : "\u00A0Days"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="terms-agreement d-flex w-full mt-[10px] flex items-start gap-2">
                  <input
                    type="checkbox"
                    id="agreeTerms"
                    checked={agreedToTerms}
                    onChange={(e) => {
                      setAgreedToTerms(e.target.checked);
                      if (e.target.checked) setTermsError(false);
                    }}
                    className={`cursor-pointer mt-1 ${
                      termsError ? "border-red-500" : "border-black"
                    }`}
                    style={{ width: "18px", height: "18px" }}
                  />
                  <label
                    htmlFor="agreeTerms"
                    className={`cursor-pointer text-[16px] ${
                      termsError ? "text-red-500" : "text-black"
                    }`}
                  >
                    {lang === "ar" ? (
                      <>
                        أنا أوافق على{" "}
                        <span
                          className="underline text-[#D83D99] font-bold"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowTermsModal(true);
                          }}
                        >
                          الشروط والأحكام
                        </span>{" "}
                        (
                        <a
                          href="/terms-and-conditions"
                          target="_blank"
                          rel="noreferrer"
                          className="underline text-[14px]"
                        >
                          إقرأ المزيد
                        </a>
                        )
                      </>
                    ) : (
                      <>
                        I agree to the{" "}
                        <span
                          className="underline text-[#D83D99] font-bold"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowTermsModal(true);
                          }}
                        >
                          Terms & Conditions
                        </span>{" "}
                        (
                        <a
                          href="/terms-and-conditions"
                          target="_blank"
                          rel="noreferrer"
                          className="underline text-[14px]"
                        >
                          Read more
                        </a>
                        )
                      </>
                    )}
                  </label>
                </div>

                <div className="my-3">
                  <p className="font-semibold mb-2 text-[14px]">
                    {lang === "ar" ? "طريقة الدفع" : "Payment method"}
                  </p>
                  <div className="rounded-md border border-gray-200 divide-y divide-gray-200 bg-white overflow-hidden">
                    <PaymentRow
                      value="paytabs"
                      selected={gateway === "paytabs"}
                      onSelect={() => setGateway("paytabs")}
                      label={lang === "ar" ? "الدفع بالبطاقة" : "Card payment"}
                      logos={
                        <>
                          <ApplePaySvg />
                          <VisaSvg />
                          <MastercardSvg />
                          <MadaSvg />
                        </>
                      }
                    />
                    <PaymentRow
                      value="tamara"
                      selected={gateway === "tamara"}
                      onSelect={() => setGateway("tamara")}
                      label={
                        lang === "ar"
                          ? "تمارا - دفعات شهرية. متوافقة مع الشريعة"
                          : "Tamara - Monthly payments. Sharia compliant"
                      }
                      logos={<TamaraSvg />}
                    />
                  </div>
                </div>

                <button className="payment uppercase">
                  {paymentLoading ? (
                    <ClipLoader
                      color={"#FFFFFF"}
                      loading={paymentLoading}
                      size={25}
                    />
                  ) : lang === "ar" ? (
                    "المتابعة إلى الدفع​"
                  ) : (
                    "Proceed to payment​"
                  )}
                </button>

                <button
                  className="mt-[5%] h-[40px] w-[100%] bg-[#ffffff] border-black border-[1px] text-black hover:text-white hover:bg-black uppercase"
                  type="button"
                  onClick={() => setShowModal(true)}
                >
                  {lang === "ar" ? "تعديل الطلب" : "Edit order"}
                </button>

                <p className="text-[#D83D99] !text-[18px] !font-[400] !mt-2">
                  {Object.values(error).map((item) => {
                    if (lang === "ar" && item === "Invalid Coupon") {
                      return "رمز الخصم غير صالح";
                    }
                    return item;
                  })}
                </p>
              </form>
            </div>
          </div>
          <Footer isLang={lang} />
          {openPopup && (
            <Popup
              openpopup={openPopup}
              isCancel={true}
              setPopup={setOpenPopup}
              title={popupMessage}
              // subTitle={'Are you sure, you want to empty the cart.'}
              onClick={() => navigate(getBundleRoute())}
              save={
                lang === "ar"
                  ? "العودة إلى الباقة"
                  : "Back to Bundle"
              }
              // cancel={'Cancel'}
              isLang={lang}
            />
          )}
          {profileCompletionModalContent}
          <TermsModal />
        </div>
      )}
    </>
  );
};
